/**
 * This is the complete endpoint list for the API.
 *
 * The whole reason we keep this in a single file is to prevent duplicates.
 */
enum EndpointsEnum {
    AddressCreateVendorAddress = "createVendorAddress",
    AddressDeleteVendorAddress = "deleteVendorAddress",
    AddressGetVendorAddresses = "getVendorAddresses",
    AddressOnCreateVendorAddress = "onCreateVendorAddress",
    AddressOnDeleteVendorAddress = "onDeleteVendorAddress",
    AddressOnGetVendorAddresses = "onGetVendorAddresses",
    AddressOnUpdateVendorAddress = "onUpdateVendorAddress",
    AddressUpdateVendorAddress = "updateVendorAddress",
    AdminConnectedClientCount = "adminConnectedClientCount",
    AdminCreateElasticCatalogIndex = "adminCreateElasticCatalogIndex",
    AdminCreateSupplier = "adminCreateSupplier",
    AdminCreateTicket = "adminCreateTicket",
    AdminGetAllSupplierCatalogs = "adminGetAllSupplierCatalogs",
    AdminGetAllSuppliers = "adminGetAllSuppliers",
    AdminGetElasticIndices = "adminGetElasticIndices",
    AdminLogin = "adminLogin",
    AdminNotification = "adminNotification",
    AdminOnAdminCreateElasticCatalogIndex = "onAdminCreateElasticCatalogIndex",
    AdminOnConnectedClientCount = "onAdminConnectedClientCount",
    AdminOnCreateSupplier = "onAdminCreateSupplier",
    AdminOnCreateTicket = "onAdminCreateTicket",
    AdminOnGetAllSupplierCatalogs = "onAdminGetAllSupplierCatalogs",
    AdminOnGetAllSuppliers = "onAdminGetAllSuppliers",
    AdminOnGetElasticIndices = "onAdminGetElasticIndices",
    AdminOnLogin = "onAdminLogin",
    AdminOnNotification = "onAdminNotification",
    AdminOnReIndexCatalogItems = "onAdminReIndexCatalogItems",
    AdminOnReSyncCatalogItems = "onAdminReSyncCatalogItems",
    AdminOnSetSupplierIndex = "onAdminSetSupplierIndex",
    AdminOnUserLookup = "onAdminUserLookup",
    AdminOnValidateCatalogIndexing = "onAdminValidateCatalogIndexing",
    AdminReIndexCatalogItems = "adminReIndexCatalogItems",
    AdminReSyncCatalogItems = "adminReSyncCatalogItems",
    AdminSetSupplierIndex = "adminSetSupplierIndex",
    AdminUserLookup = "adminUserLookup",
    AdminValidateCatalogIndexing = "adminValidateCatalogIndexing",
    AutomationOnUpdateAutomation = "onUpdateAutomation",
    AutomationOnUpdateAutomationItems = "onUpdateAutomationItems",
    AutomationOnUpdateEmailExport = "onUpdateEmailExport",
    AutomationUpdateAutomation = "updateAutomation",
    AutomationUpdateAutomationItems = "updateAutomationItems",
    AutomationUpdateEmailExport = "updateEmailExport",
    CatalogItemCreateCatalogItem = "createCatalogItem",
    CatalogItemDeleteCatalogItem = "deleteCatalogItem",
    CatalogItemGetCatalogItem = "getCatalogItem",
    CatalogItemGetCatalogItems = "getCatalogItems",
    CatalogItemGetProductSources = "getProductSources",
    CatalogItemOnCreateCatalogItem = "onCreateCatalogItem",
    CatalogItemOnDeleteCatalogItem = "onDeleteCatalogItem",
    CatalogItemOnGetCatalogItem = "onGetCatalogItem",
    CatalogItemOnGetCatalogItems = "onGetCatalogItems",
    CatalogItemOnGetProductSources = "onGetProductSources",
    CatalogItemOnTypeaheadCatalogItem = "onTypeaheadCatalogItem",
    CatalogItemOnTypeaheadProductSources = "onTypeaheadProductSources",
    CatalogItemOnTypeaheadVendorSourceCatalogItems = "onTypeaheadVendorSourceCatalogItems",
    CatalogItemOnUpdateCatalogItem = "onUpdateCatalogItem",
    CatalogItemOnUpdateProductSource = "onUpdateProductSource",
    CatalogItemOnUpdateProductSources = "onUpdateProductSources",
    CatalogItemTypeaheadCatalogItem = "typeaheadCatalogItem",
    CatalogItemTypeaheadProductSources = "typeaheadProductSources",
    CatalogItemTypeaheadVendorSourceCatalogItems = "typeaheadVendorSourceCatalogItems",
    CatalogItemUpdateCatalogItem = "updateCatalogItem",
    CatalogItemUpdateProductSource = "updateProductSource",
    CatalogItemUpdateProductSources = "updateProductSources",
    CatalogsCreateCatalog = "createCatalog",
    CatalogsCreatePriceGroup = "createPriceGroup",
    CatalogsDeleteCatalog = "deleteCatalog",
    CatalogsGetCatalog = "getCatalog",
    CatalogsGetCatalogCSVCategoryTemplate = "getCatalogCSVCategoryTemplate",
    CatalogsGetCatalogCSVInventory = "getCatalogCSVInventory",
    CatalogsGetCatalogCSVItemTemplate = "getCatalogCSVItemTemplate",
    CatalogsGetCatalogCSVPriceGroups = "getCatalogCSVPriceGroups",
    CatalogsGetCatalogCSVPriceUpdate = "getCatalogCSVPriceUpdate",
    CatalogsGetCatalogs = "getCatalogs",
    CatalogsGetPriceGroups = "getCatalogsPriceGroups",
    CatalogsGetPricingFormulas = "getCatalogsPricingFormulas",
    CatalogsGetStockLevels = "getStockLevels",
    CatalogsOnCreateCatalog = "onCreateCatalog",
    CatalogsOnCreatePriceGroup = "onCreatePriceGroup",
    CatalogsOnDeleteCatalog = "onDeleteCatalog",
    CatalogsOnGetCatalog = "onGetCatalog",
    CatalogsOnGetCatalogCSVCategoryTemplate = "onGetCatalogCSVCategoryTemplate",
    CatalogsOnGetCatalogCSVInventory = "onGetCatalogCSVInventory",
    CatalogsOnGetCatalogCSVItemTemplate = "onGetCatalogCSVItemTemplate",
    CatalogsOnGetCatalogCSVPriceGroups = "onGetCatalogCSVPriceGroups",
    CatalogsOnGetCatalogCSVPriceUpdate = "onGetCatalogCSVPriceUpdate",
    CatalogsOnGetCatalogs = "onGetCatalogs",
    CatalogsOnGetPriceGroups = "onGetCatalogsPriceGroups",
    CatalogsOnGetPricingFormulas = "onGetCatalogsPricingFormulas",
    CatalogsOnGetStockLevels = "onGetStockLevels",
    CatalogsOnPerformCatalogCSVCategoryUpdate = "onPerformCatalogCSVCategoryUpdate",
    CatalogsOnPerformCatalogCSVInventoryUpdate = "onPerformCatalogCSVInventoryUpdate",
    CatalogsOnPerformCatalogCSVItemTemplateUpdate = "onPerformCatalogCSVItemTemplateUpdate",
    CatalogsOnPerformCatalogCSVLargeItemTemplateUpdate = "onPerformCatalogCSVLargeItemTemplateUpdate",
    CatalogsOnPerformCatalogCSVPriceGroupUpdate = "onPerformCatalogCSVPriceGroupUpdate",
    CatalogsOnPerformCatalogCSVPriceUpdate = "onPerformCatalogCSVPriceUpdate",
    CatalogsOnUpdateCatalog = "onUpdateCatalog",
    CatalogsOnUpdatePriceGroup = "onUpdatePriceGroup",
    CatalogsPerformCatalogCSVCategoryUpdate = "performCatalogCSVCategoryUpdate",
    CatalogsPerformCatalogCSVInventoryUpdate = "performCatalogCSVInventoryUpdate",
    CatalogsPerformCatalogCSVItemTemplateUpdate = "performCatalogCSVItemTemplateUpdate",
    CatalogsPerformCatalogCSVLargeItemTemplateUpdate = "performCatalogCSVLargeItemTemplateUpdate",
    CatalogsPerformCatalogCSVPriceGroupUpdate = "performCatalogCSVPriceGroupUpdate",
    CatalogsPerformCatalogCSVPriceUpdate = "performCatalogCSVPriceUpdate",
    CatalogsUpdateCatalog = "updateCatalog",
    CatalogsUpdatePriceGroup = "updatePriceGroup",
    CategoriesApplyAttributeDefault = "applyAttributeDefault",
    CategoriesCreateAttribute = "createAttribute",
    CategoriesCreateCategory = "createCategory",
    CategoriesDeleteCategory = "deleteCategory",
    CategoriesGetAttributes = "getAttributes",
    CategoriesGetCategories = "getCategories",
    CategoriesGetCategory = "getCategory",
    CategoriesGetCategoryCatalogItems = "getCategoryCatalogItems",
    CategoriesGetSelectedCategoryHierarchy = "getSelectedCategoryHierarchy",
    CategoriesGetSubCategories = "getSubCategories",
    CategoriesOnApplyAttributeDefault = "onApplyAttributeDefault",
    CategoriesOnCreateAttribute = "onCreateAttribute",
    CategoriesOnCreateCategory = "onCreateCategory",
    CategoriesOnDeleteCategory = "onDeleteCategory",
    CategoriesOnGetAttributes = "onGetAttributes",
    CategoriesOnGetCategories = "onGetCategories",
    CategoriesOnGetCategory = "onGetCategory",
    CategoriesOnGetCategoryCatalogItems = "onGetCategoryCatalogItems",
    CategoriesOnGetSelectedCategoryHierarchy = "onGetSelectedCategoryHierarchy",
    CategoriesOnGetSubCategories = "onGetSubCategories",
    CategoriesOnUpdateAttribute = "onUpdateAttribute",
    CategoriesOnUpdateCategory = "onUpdateCategory",
    CategoriesUpdateAttribute = "updateAttribute",
    CategoriesUpdateCategory = "updateCategory",
    ClientCreateClient = "createClient",
    ClientDeleteClient = "deleteClient",
    ClientGetClient = "getClient",
    ClientGetClients = "getClients",
    ClientOnCreateClient = "onCreateClient",
    ClientOnDeleteClient = "onDeleteClient",
    ClientOnGetClient = "onGetClient",
    ClientOnGetClients = "onGetClients",
    ClientOnUpdateClient = "onUpdateClient",
    ClientUpdateClient = "updateClient",
    DashboardLoadDashboard = "loadDashboard",
    DashboardOnLoadDashboard = "onLoadDashboard",
    ElasticSearchCreateCatalogIndex = "elasticSearchCreateCatalogIndex",
    ElasticSearchOnCreateCatalogIndex = "onElasticSearchCreateCatalogIndex",
    ElasticSearchOnSyncCatalog = "onElasticSearchSyncCatalog",
    ElasticSearchSyncCatalog = "elasticSearchSyncCatalog",
    ExportCreateExport = "createExport",
    ExportGetExport = "getExport",
    ExportGetExports = "getExports",
    ExportOnCreateExport = "onCreateExport",
    ExportOnGetExport = "onGetExport",
    ExportOnGetExports = "onGetExports",
    FileUploadCreateFileUpload = "createFileUpload",
    FileUploadDeleteFileUpload = "deleteFileUpload",
    FileUploadGetFileUpload = "getFileUpload",
    FileUploadGetSignedUrl = "getSignedURL",
    FileUploadGetAttachmentSignedUrl = "getAttachmentSignedURL",
    FileUploadOnCreateFileUpload = "onCreateFileUpload",
    FileUploadOnDeleteFileUpload = "onDeleteFileUpload",
    FileUploadOnGetFileUpload = "onGetFileUpload",
    FileUploadOnGetSignedUrl = "onGetSignedURL",
    FileUploadOnGetAttachmentSignedUrl = "onGetAttachmentSignedURL",
    FileUploadOnUpdateFileUpload = "onUpdateFileUpload",
    FileUploadUpdateFileUpload = "updateFileUpload",
    ForecastGetForecastGroup = "getForecastGroup",
    ForecastGetForecastGroups = "getForecastGroups",
    ForecastOnGetForecastGroup = "onGetForecastGroup",
    ForecastOnGetForecastGroups = "onGetForecastGroups",
    ForecastOnUpdateForecastGroup = "onUpdateForecastGroup",
    ForecastOnUpdateForecastItems = "onUpdateForecastItems",
    ForecastUpdateForecastGroup = "updateForecastGroup",
    ForecastUpdateForecastItems = "updateForecastItems",
    MaterialGetMaterials = "getMaterials",
    MaterialGetMaterialsReport = "getMaterialsReport",
    MaterialOnGetMaterials = "onGetMaterials",
    MaterialOnGetMaterialsReport = "onGetMaterialsReport",
    MaterialOnProcessMaterial = "onProcessMaterial",
    MaterialOnTypeahead = "onMaterialsTypeahead",
    MaterialProcessMaterial = "processMaterial",
    MaterialTypeahead = "materialsTypeahead",
    Notify = "notify",
    OrderBulkOrderImport = "bulkOrderImport",
    OrderBulkOrderImportProgress = "bulkOrderImportProgress",
    OrderBulkOrderImportStart = "bulkOrderImportStart",
    OrderConvertQuoteToOrder = "convertQuoteToOrder",
    OrderCreateOrder = "createOrder",
    OrderCreateOrderFromInventory = "createOrderFromInventory",
    OrderCreatePackingLists = "createPackingLists",
    OrderCreatePickList = "createPickList",
    OrderDeleteOrder = "deleteOrder",
    OrderEntryBulkOrderSubmit = "bulkOrderEntrySubmit",
    OrderEntryBulkOrderSubmitProgress = "bulkOrderEntrySubmitProgress",
    OrderEntryBulkOrderSubmitStart = "bulkOrderEntrySubmitStart",
    OrderEntryCreateOrderEntryItem = "createOrderEntryItem",
    OrderEntryCreateOrderEntryItems = "createOrderEntryItems",
    OrderEntryDeleteOrderEntryItem = "deleteOrderEntryItem",
    OrderEntryGetOrderEntryDetail = "getOrderEntryDetail",
    OrderEntryGetOrderEntryItem = "getOrderEntryItem",
    OrderEntryGetOrderEntryItems = "getOrderEntryItems",
    OrderEntryBackorderLimitExceeded = "backorderLimitExceeded",
    OrderEntryInsufficientInventory = "insufficientInventory",
    OrderEntryPendingItemsOnRelease = "pendingItemsOnRelease",
    OrderEntryOnBulkOrderSubmit = "onBulkOrderEntrySubmit",
    OrderEntryOnCreateOrderEntryItem = "onCreateOrderEntryItem",
    OrderEntryOnCreateOrderEntryItems = "onCreateOrderEntryItems",
    OrderEntryOnDeleteOrderEntryItem = "onDeleteOrderEntryItem",
    OrderEntryOnGetOrderEntryDetail = "onGetOrderEntryDetail",
    OrderEntryOnGetOrderEntryItem = "onGetOrderEntryItem",
    OrderEntryOnGetOrderEntryItems = "onGetOrderEntryItems",
    OrderEntryOnProcessOrderEntryItems = "onProcessOrderEntryItems",
    OrderEntryOnReconcileOfflineOrderEntryItems = "onReconcileOfflineOrderEntryItems",
    OrderEntryOnRenumberOrderItems = "onRenumberOrderItems",
    OrderEntryOnResendOrderAutomation = "onResendOrderAutomation",
    OrderEntryOnUpdateOrderEntryDetail = "onUpdateOrderEntryDetail",
    OrderEntryOnUpdateSortOrder = "onUpdateOrderItemsSortOrder",
    OrderEntryOnUpdateOrderFineDetails = "onUpdateOrderEntryFineDetails",
    OrderEntryOnUpdateOrderEntryItem = "onUpdateOrderEntryItem",
    OrderEntryOnValidateBulkOrderSubmit = "onValidateBulkOrderEntrySubmit",
    OrderEntryProcessOrderEntryItems = "processOrderEntryItems",
    OrderEntryReconcileOfflineOrderEntryItems = "reconcileOfflineOrderEntryItems",
    OrderEntryRenumberOrderItems = "renumberOrderItems",
    OrderEntryResendOrderAutomation = "resendOrderAutomation",
    OrderEntryUpdateOrderEntryDetail = "updateOrderEntryDetail",
    OrderEntryUpdateSortOrder = "updateOrderItemsSortOrder",
    OrderEntryUpdateOrderFineDetails = "updateOrderEntryFineDetails",
    OrderEntryUpdateOrderEntryItem = "updateOrderEntryItem",
    OrderEntryValidateBulkOrderSubmit = "validateBulkOrderEntrySubmit",
    OrderGetBatchOrders = "getBatchOrders",
    OrderGetOrder = "getOrder",
    OrderGetOrderNamesByGuid = "getOrderNamesByGuid",
    OrderGetOrders = "getOrders",
    OrderGetOrdersPackingList = "getOrdersPackingList",
    OrderGetOrdersPickList = "getOrdersPickList",
    OrderGetOrdersTypeahead = "getOrdersTypeahead",
    OrderGetPackingList = "getPackingList",
    OrderGetPackingLists = "getPackingLists",
    OrderGetPickList = "getPickList",
    OrderGetPickLists = "getPickLists",
    OrderOnBulkOrderImport = "onBulkOrderImport",
    OrderOnConvertQuoteToOrder = "onConvertQuoteToOrder",
    OrderOnCreateOrder = "onCreateOrder",
    OrderOnCreateOrderFromInventory = "onCreateOrderFromInventory",
    OrderOnCreatePackingLists = "onCreatePackingLists",
    OrderOnCreatePickList = "onCreatePickList",
    OrderOnDeleteOrder = "onDeleteOrder",
    OrderOnGetBatchOrders = "onGetBatchOrders",
    OrderOnGetOrder = "onGetOrder",
    OrderOnGetOrderNamesByGuid = "onGetOrderNamesByGuid",
    OrderOnGetOrders = "onGetOrders",
    OrderOnGetOrdersPackingList = "onGetOrdersPackingList",
    OrderOnGetOrdersPickList = "onGetOrdersPickList",
    OrderOnGetOrdersTypeahead = "onGetOrdersTypeahead",
    OrderOnGetPackingList = "onGetPackingList",
    OrderOnGetPackingLists = "onGetPackingLists",
    OrderOnGetPickList = "onGetPickList",
    OrderOnGetPickLists = "onGetPickLists",
    OrderOnReleaseOrderCommission = "onReleaseOrderCommission",
    OrderOnRemake = "onRemakeOrder",
    OrderOnResendEmail = "onResendEmail",
    OrderOnUpdatePackingList = "onUpdatePackingList",
    OrderOnUpdatePackingListLock = "onUpdatePackingListLock",
    OrderOnUpdatePickList = "onUpdatePickList",
    OrderOnUpdatePickListLock = "onUpdatePickListLock",
    OrderReleaseOrderCommission = "releaseOrderCommission",
    OrderRemake = "remakeOrder",
    OrderResendEmail = "resendEmail",
    OrderUpdatePackingList = "updatePackingList",
    OrderUpdatePackingListLock = "updatePackingListLock",
    OrderUpdatePickList = "updatePickList",
    OrderUpdatePickListLock = "updatePickListLock",
    PriceGroupsGetPriceGroups = "getPriceGroups",
    PriceGroupsOnGetPriceGroups = "onGetPriceGroups",
    ProfileChangePassword = "changePassword",
    ProfileOnChangePassword = "onChangePassword",
    ProfileOnSaveUserPreferences = "onSaveUserPreferences",
    ProfileSaveUserPreferences = "saveUserPreferences",
    ProjectsGetProject = "getProject",
    ProjectsGetProjects = "getProjects",
    ProjectsGetProjectsForVendor = "GetProjectsForVendor",
    ProjectsOnGetProject = "onGetProject",
    ProjectsOnGetProjects = "onGetProjects",
    ProjectsOnGetProjectsForVendor = "onGetProjectsForVendor",
    ProjectsOnProcessProject = "onProcessProject",
    ProjectsProcessProject = "processProject",
    PurchaseOrderFinalizePOShipment = "finalizePOShipment",
    PurchaseOrderGetPOShipments = "getPOShipments",
    PurchaseOrderGetPOShipment = "getPOShipment",
    PurchaseOrderGetPurchaseOrder = "getPurchaseOrder",
    PurchaseOrderGetPurchaseOrders = "getPurchaseOrders",
    PurchaseOrderGetVendorSource = "getVendorSource",
    PurchaseOrderGetVendorSources = "getVendorSources",
    PurchaseOrderOnFinalizePOShipment = "onFinalizePOShipment",
    PurchaseOrderOnGetPOShipments = "onGetPOShipments",
    PurchaseOrderOnGetPOShipment = "onGetPOShipment",
    PurchaseOrderOnGetPurchaseOrder = "onGetPurchaseOrder",
    PurchaseOrderOnGetPurchaseOrders = "onGetPurchaseOrders",
    PurchaseOrderOnGetVendorSource = "onGetVendorSource",
    PurchaseOrderOnGetVendorSources = "onGetVendorSources",
    PurchaseOrderOnProcessPOShipment = "onProcessPOShipment",
    PurchaseOrderOnProcessPOShipmentItem = "onProcessPOShipmentItem",
    PurchaseOrderOnProcessPurchaseOrder = "onProcessPurchaseOrder",
    PurchaseOrderOnProcessPurchaseOrderItem = "onProcessPurchaseOrderItem",
    PurchaseOrderOnProcessVendorSource = "onProcessVendorSource",
    PurchaseOrderOnSendPurchaseOrder = "onSendPurchaseOrder",
    PurchaseOrderProcessPOShipment = "processPOShipment",
    PurchaseOrderProcessPOShipmentItem = "processPOShipmentItem",
    PurchaseOrderProcessPurchaseOrder = "processPurchaseOrder",
    PurchaseOrderProcessPurchaseOrderItem = "processPurchaseOrderItem",
    PurchaseOrderProcessVendorSource = "processVendorSource",
    PurchaseOrderSendPurchaseOrder = "sendPurchaseOrder",
    PurchaseOrderAutoPopulate = "purchaseOrderAutoPopulate",
    PurchaseOrderOnAutoPopulate = "onPurchaseOrderAutoPopulate",
    QBDCreate = "qbdCreate",
    QBDCreateCatalogItems = "qbdCreateCatalogItems",
    QBDCreateVendors = "qbdCreateVendors",
    QBDGenerateWebConnectorConfig = "qbdGenerateWebConnectorConfig",
    QBDMapper = "qbdMapper",
    QBDOnCreate = "onQBDCreate",
    QBDOnCreateCatalogItems = "onQBDCreateCatalogItems",
    QBDOnCreateVendors = "onQBDCreateVendors",
    QBDOnGenerateWebConnectorConfig = "onQbdGenerateWebConnectorConfig",
    QBDOnMapper = "onQBDMapper",
    QBDOnPerformInitialDataPull = "onQBDPerformInitialDataPull",
    QBDPerformInitialDataPull = "qbdPerformInitialDataPull",
    QBDSyncVendorStart = "QBDSyncVendorStart",
    QBDSyncVendorUpdate = "QBDSyncVendorUpdate",
    QBOCreateInvoice = "qboCreateInvoice",
    QBOGetAllCustomers = "qboGetAllCustomers",
    QBOGetBankAndOtherCurrentAssetAccounts = "qboGetBankAndOtherCurrentAssetAccounts",
    QBOGetCustomSalesFields = "qboGetCustomSalesFields",
    QBOGetCustomers = "qboGetCustomers",
    QBOGetIncomeAccounts = "qboGetIncomeAccounts",
    QBOGetPDFInvoice = "qboGetPdfInvoice",
    QBOGetPaymentMethods = "qboGetPaymentMethods",
    QBOGetSalesTerms = "qboGetTerms",
    QBOMarkInvoicePaid = "qboMarkInvoicePaid",
    QBOOAuthDisconnect = "qboOauthDisconnect",
    QBOOAuthStart = "qboOauthStart",
    QBOOnCreateInvoice = "onQboCreateInvoice",
    QBOOnGetAllCustomers = "onQboGetAllCustomers",
    QBOOnGetBankAndOtherCurrentAssetAccounts = "onQboGetBankAndOtherCurrentAssetAccounts",
    QBOOnGetCustomSalesFields = "onQboGetCustomSalesFields",
    QBOOnGetCustomers = "onQboGetCustomers",
    QBOOnGetIncomeAccounts = "onQboGetIncomeAccounts",
    QBOOnGetPDFInvoice = "onQboGetPdfInvoice",
    QBOOnGetPaymentMethods = "onQboGetPaymentMethods",
    QBOOnGetSalesTerms = "onQboGetTerms",
    QBOOnMarkInvoicePaid = "onQboMarkInvoicePaid",
    QBOOnOAuthDisconnect = "onQboOauthDisconnect",
    QBOOnOAuthStart = "onQboOauthStart",
    QBOOnSendInvoice = "onQboSendInvoice",
    QBOOnSetBulkVendorCustomerDetails = "onQboSetBulkVendorCustomerDetails",
    QBOOnSetCatalogItemIncomeAccount = "onQboSetCatalogItemIncomeAccount",
    QBOOnSetDefaultPOField = "onQboSetDefaultPOField",
    QBOOnSetDefaultSalesTerm = "onQboSetDefaultSalesTerm",
    QBOOnSetVendorCustomerDetails = "onQboSetVendorCustomerDetails",
    QBOOnSyncCatalogItems = "qboOnSyncCatalogItems",
    QBOOnSyncCustomers = "qboOnSyncCustomers",
    QBOOnSyncInventory = "onQboSyncInventory",
    QBOSendInvoice = "qboSendInvoice",
    QBOSetBulkVendorCustomerDetails = "qboSetBulkVendorCustomerDetails",
    QBOSetCatalogItemIncomeAccount = "qboSetCatalogItemIncomeAccount",
    QBOSetDefaultPOField = "qboSetDefaultPOField",
    QBOSetDefaultSalesTerm = "qboSetDefaultSalesTerm",
    QBOSetVendorCustomerDetails = "qboSetVendorCustomerDetails",
    QBOSyncCatalogItems = "qboSyncCatalogItems",
    QBOSyncCatalogItemsEnd = "qboSyncCatalogItemsEnd",
    QBOSyncCatalogItemsStart = "qboSyncCatalogItemsStart",
    QBOSyncCatalogItemsUpdate = "qboSyncCatalogItemsUpdate",
    QBOSyncCustomers = "qboSyncCustomers",
    QBOSyncInventory = "qboSyncInventory",
    ReportGetCommissionReport = "getCommissionReport",
    ReportGetCommissionTiersReport = "getCommissionTiersReport",
    ReportGetCoopReport = "getCoopReport",
    ReportGetOrdersDetailReport = "getOrdersDetailReport",
    ReportGetReportData = "getReportData",
    ReportGetReportSalesByUser = "getReportSalesByUser",
    ReportGetSalesByUserProductDetail = "getSalesByUserProductDetail",
    ReportGetSpiffReport = "getSpiffReport",
    ReportGetVolumeRebateReport = "getVolumeRebateReport",
    ReportOnGetCommissionReport = "onGetCommissionReport",
    ReportOnGetCommissionTiersReport = "onGetCommissionTiersReport",
    ReportOnGetCoopReport = "onGetCoopReport",
    ReportOnGetOrdersDetailReport = "onGetOrdersDetailReport",
    ReportOnGetReportData = "onGetReportData",
    ReportOnGetReportSalesByUser = "onGetReportSalesByUser",
    ReportOnGetSalesByUserProductDetail = "onGetSalesByUserProductDetail",
    ReportOnGetSpiffReport = "onGetSpiffReport",
    ReportOnGetVolumeRebateReport = "onGetVolumeRebateReport",
    ShipmentCreateShipment = "createShipment",
    ShipmentCreateShipmentFromPackingList = "createShipmentFromPackingList",
    ShipmentCreateShipmentFromPurchaseOrder = "createShipmentFromPurchaseOrder",
    ShipmentCreateShipmentGroup = "createShipmentGroup",
    ShipmentDeleteShipmentGroup = "deleteShipmentGroup",
    ShipmentGetBatchShipments = "getBatchShipments",
    ShipmentGetShipment = "getShipment",
    ShipmentGetShipmentGroup = "getShipmentGroup",
    ShipmentGetShipmentGroups = "getShipmentGroups",
    ShipmentOnCreateShipment = "onCreateShipment",
    ShipmentPendingItemsOnRelease = "shipmentPendingItemsOnRelease",
    ShipmentOnCreateShipmentFromPackingList = "onCreateShipmentFromPackingList",
    ShipmentOnCreateShipmentFromPurchaseOrder = "onCreateShipmentFromPurchaseOrder",
    ShipmentOnCreateShipmentGroup = "onCreateShipmentGroup",
    ShipmentOnDeleteShipmentGroup = "onDeleteShipmentGroup",
    ShipmentOnGetBatchShipments = "onGetBatchShipments",
    ShipmentOnGetShipment = "onGetShipment",
    ShipmentOnGetShipmentGroup = "onGetShipmentGroup",
    ShipmentOnGetShipmentGroups = "onGetShipmentGroups",
    ShipmentOnUpdateShipment = "onUpdateShipment",
    ShipmentOnUpdateShipmentGroup = "onUpdateShipmentGroup",
    ShipmentOnUpdateShipmentStatus = "onUpdateShipmentStatus",
    ShipmentOnVoidShipment = "onVoidShipment",
    ShipmentUpdateShipment = "updateShipment",
    ShipmentUpdateShipmentGroup = "updateShipmentGroup",
    ShipmentUpdateShipmentStatus = "updateShipmentStatus",
    ShipmentVoidShipment = "voidShipment",
    ShipmentDeleteShipment = "deleteShipment",
    ShipmentOnDeleteShipment = "onDeleteShipment",
    ShipstationGetCarriers = "getShipstationCarriers",
    ShipstationGetPackageTypesForCarriers = "getShipstationPackageTypesForCarrier",
    ShipstationGetRates = "getShipstationRates",
    ShipstationGetServicesForCarriers = "getShipstationServicesForCarrier",
    ShipstationOnGetCarriers = "onGetShipstationCarriers",
    ShipstationOnGetPackageTypesForCarriers = "onGetShipstationPackageTypesForCarrier",
    ShipstationOnGetRates = "onGetShipstationRates",
    ShipstationOnGetServicesForCarriers = "onGetShipstationServicesForCarrier",
    ShipstationOnRemoveApiKeys = "onRemoveShipstationApiKeys",
    ShipstationOnSetApiKeys = "onSetShipstationApiKeys",
    ShipstationOnUpgradeShipping = "onShipstationUpgradeShipping",
    ShipstationOnVoidLabel = "onShipstationVoidLabel",
    ShipstationRemoveApiKeys = "removeShipstationApiKeys",
    ShipstationSetApiKeys = "setShipstationApiKeys",
    ShipstationUpgradeShipping = "shipstationUpgradeShipping",
    ShipstationVoidLabel = "shipstationVoidLabel",
    ShopifyBeginOAuth = "shopifyBeginOAuth",
    ShopifyFinishPartialOAuth = "shopifyFinishPartialOAuth",
    ShopifyOnFinishPartialOAuth = "shopifyOnFinishPartialOAuth",
    ShopifyDisconnect = "shopifyDisconnect",
    ShopifyOnBeginOAuth = "onShopifyBeginOAuth",
    ShopifyOnDisconnect = "onShopifyDisconnect",
    ShopifyOnPullOrders = "shopifyOnPullOrders",
    ShopifyOnSyncInventory = "shopifyOnSyncInventory",
    ShopifyOnSyncProducts = "shopifyOnSyncProducts",
    ShopifyPullOrders = "shopifyPullOrders",
    ShopifySyncInventory = "shopifySyncInventory",
    ShopifySyncProducts = "shopifySyncProducts",
    ShopifyPushInventory = "shopifyPushInventory",
    ShopifyOnPushInventory = "onShopifyPushInventory",
    SlackBeginOAuth = "slackBeginOAuth",
    SlackDisconnect = "slackDisconnect",
    SlackOnBeginOAuth = "slackOnBeginOAuth",
    SlackOnDisconnect = "slackOnDisconnect",
    SquareCreateOrderAndCharge = "squareCreateOrderAndCharge",
    SquareGetCustomer = "squareGetCustomer",
    SquareGetCustomers = "squareGetCustomers",
    SquareOAuthRevoke = "squareOauthRevoke",
    SquareOAuthStart = "squareOauthStart",
    SquareOnCreateOrderAndCharge = "onSquareCreateOrderAndCharge",
    SquareOnGetCustomer = "onSquareGetCustomer",
    SquareOnGetCustomers = "onSquareGetCustomers",
    SquareOnOAuthRevoke = "onSquareOauthRevoke",
    SquareOnOAuthStart = "onSquareOauthStart",
    SquareOnSaveVendorCustomerMap = "onSquareSaveVendorCustomerMap",
    SquareOnSearchCustomers = "onSquareSearchCustomers",
    SquareSaveVendorCustomerMap = "squareSaveVendorCustomerMap",
    SquareSearchCustomers = "squareSearchCustomers",
    SupplierCreateCoopEntry = "createCoopEntry",
    SupplierCreateRebateGroup = "createRebateGroup",
    SupplierCreateSpiffGroup = "createSpiffGroup",
    SupplierDeleteRebateGroup = "deleteRebateGroup",
    SupplierDeleteSpiffGroup = "deleteSpiffGroup",
    SupplierGetCommissionTiers = "getCommissionTiers",
    SupplierGetCoopEntries = "getCoopEntries",
    SupplierGetRebateGroup = "getRebateGroup",
    SupplierGetRebateGroups = "getRebateGroups",
    SupplierGetSpiffGroup = "getSpiffGroup",
    SupplierGetSpiffGroups = "getSpiffGroups",
    SupplierGetSupplier = "getSupplier",
    SupplierGetSupplierUserVendors = "getSupplierUserVendors",
    SupplierOnCreateCoopEntry = "onCreateCoopEntry",
    SupplierOnCreateRebateGroup = "onCreateRebateGroup",
    SupplierOnCreateSpiffGroup = "onCreateSpiffGroup",
    SupplierOnDeleteRebateGroup = "onDeleteRebateGroup",
    SupplierOnDeleteSpiffGroup = "onDeleteSpiffGroup",
    SupplierOnGetCommissionTiers = "onGetCommissionTiers",
    SupplierOnGetCoopEntries = "onGetCoopEntries",
    SupplierOnGetRebateGroup = "onGetRebateGroup",
    SupplierOnGetRebateGroups = "onGetRebateGroups",
    SupplierOnGetSpiffGroup = "onGetSpiffGroup",
    SupplierOnGetSpiffGroups = "onGetSpiffGroups",
    SupplierOnGetSupplier = "onGetSupplier",
    SupplierOnGetSupplierUserVendors = "onGetSupplierUserVendors",
    SupplierOnUpdateCommissionTiers = "onUpdateCommissionTiers",
    SupplierOnUpdateCoopEntry = "onUpdateCoopEntry",
    SupplierOnUpdateRebateGroup = "onUpdateRebateGroup",
    SupplierOnUpdateSpiffGroup = "onUpdateSpiffGroup",
    SupplierOnUpdateSpiffGroupItems = "onUpdateSpiffGroupItems",
    SupplierOnUpdateSpiffGroupUsers = "onUpdateSpiffGroupUsers",
    SupplierOnUpdateSupplier = "onUpdateSupplier",
    SupplierOnUpdateSupplierIntegrations = "onUpdateSupplierIntegrations",
    SupplierOnUpdateSupplierSettings = "onUpdateSupplierSettings",
    SupplierOnUpdateSupplierUserVendorMap = "onUpdateSupplierUserVendorMap",
    SupplierUpdateCommissionTiers = "updateCommissionTiers",
    SupplierUpdateCoopEntry = "updateCoopEntry",
    SupplierUpdateRebateGroup = "updateRebateGroup",
    SupplierUpdateSpiffGroup = "updateSpiffGroup",
    SupplierUpdateSpiffGroupItems = "updateSpiffGroupItems",
    SupplierUpdateSpiffGroupUsers = "updateSpiffGroupUsers",
    SupplierUpdateSupplier = "updateSupplier",
    SupplierUpdateSupplierIntegrations = "updateSupplierIntegrations",
    SupplierUpdateSupplierSettings = "updateSupplierSettings",
    SupplierUpdateSupplierUserVendorMap = "updateSupplierUserVendorMap",
    SuppliersGetHolidays = "getHolidays",
    SuppliersGetServiceLevels = "getServiceLevels",
    SuppliersOnGetHolidays = "onGetHolidays",
    SuppliersOnGetServiceLevels = "onGetServiceLevels",
    SuppliersOnProcessHolidays = "onProcessHolidays",
    SuppliersOnProcessServiceLevels = "onProcessServiceLevels",
    SuppliersProcessHolidays = "processHolidays",
    SuppliersProcessServiceLevels = "processServiceLevels",
    TokenDeleteToken = "deleteToken",
    TokenGenerateSupplierUserToken = "generateSupplierUserToken",
    TokenGenerateSupplierVendorToken = "generateSupplierVendorToken",
    TokenGenerateVendorUserToken = "generateVendorUserToken",
    TokenGetAllSupplierTokens = "getAllSupplierTokens",
    TokenGetSupplierUsersTokens = "getSupplierUsersTokens",
    TokenGetSupplierVendorUsersTokens = "getSupplierVendorUsersTokens",
    TokenOnDeleteToken = "onDeleteToken",
    TokenOnGenerateSupplierUserToken = "onGenerateSupplierUserToken",
    TokenOnGenerateSupplierVendorToken = "onGenerateSupplierVendorToken",
    TokenOnGenerateVendorUserToken = "onGenerateVendorUserToken",
    TokenOnGetAllSupplierTokens = "onGetAllSupplierTokens",
    TokenOnGetSupplierUsersTokens = "onGetSupplierUsersTokens",
    TokenOnGetSupplierVendorUsersTokens = "onGetSupplierVendorUsersTokens",
    TokenOnResendTokenEmail = "onResendTokenEmail",
    TokenOnTypeaheadLookupByTokenType = "onTypeaheadLookupByTokenType",
    TokenOnUpdateTokenConfiguration = "onUpdateTokenConfiguration",
    TokenResendTokenEmail = "resendTokenEmail",
    TokenTypeaheadLookupByTokenType = "typeaheadLookupByTokenType",
    TokenUpdateTokenConfiguration = "updateTokenConfiguration",
    UserOnSubmitReview = "onSubmitReview",
    UserSubmitReview = "submitReview",
    VendorsCreateVendor = "createVendor",
    VendorsCreateVendorCsv = "createVendorCsv",
    VendorsCreateVendorUserCsv = "createVendorUserCsv",
    VendorsGetVendor = "getVendor",
    VendorsGetVendorCsvEntry = "getVendorCsvEntry",
    VendorsGetVendorPriceGroupMap = "getVendorPriceGroupMap",
    VendorsGetVendors = "getVendors",
    VendorsGetVendorsV2 = "getVendorsV2",
    VendorsOnCreateVendor = "onCreateVendor",
    VendorsOnCreateVendorCsv = "onCreateVendorCsv",
    VendorsOnCreateVendorUserCsv = "onCreateVendorUserCsv",
    VendorsOnGetVendor = "onGetVendor",
    VendorsOnGetVendorCsvEntry = "onGetVendorCsvEntry",
    VendorsOnGetVendorPriceGroupMap = "onGetVendorPriceGroupMap",
    VendorsOnGetVendors = "onGetVendors",
    VendorsOnGetVendorsV2 = "onGetVendorsV2",
    VendorsOnUpdateVendor = "onUpdateVendor",
    VendorsOnUpdateVendorPriceGroupMap = "onUpdateVendorPriceGroupMap",
    VendorsUpdateVendor = "updateVendor",
    VendorsUpdateVendorPriceGroupMap = "updateVendorPriceGroupMap",
    WarehouseGetWarehouses = "getWarehouses",
    WarehouseOnGetWarehouses = "onGetWarehouses",
    WarehouseOnProcessWarehouse = "onProcessWarehouse",
    WarehouseProcessWarehouse = "processWarehouse",
    WooCommerceInitialize = "wooCommerceInitialize",
    WooCommerceOnInitialize = "onWooCommerceInitialize",
    WooCommerceOnPullCatalogItems = "onWooCommercePullCatalogItems",
    WooCommerceOnPullInventory = "onWooCommercePullInventory",
    WooCommerceOnPullOrders = "onWooCommercePullOrders",
    WooCommerceOnPushCatalogItems = "onWooCommercePushCatalogItems",
    WooCommerceOnValidation = "onWooCommerceValidation",
    WooCommercePullCatalogItems = "wooCommercePullCatalogItems",
    WooCommercePullInventory = "wooCommercePullInventory",
    WooCommercePullOrders = "wooCommercePullOrders",
    WooCommercePushCatalogItems = "wooCommercePushCatalogItems",
    WooCommerceValidation = "wooCommerceValidation",
    ZohoDisconnect = "zohoDisconnect",
    ZohoGetAccounts = "zohoGetAccounts",
    ZohoOnDisconnect = "onZohoDisconnect",
    ZohoOnGetAccounts = "onZohoGetAccounts",
    ZohoProcessingGetAccounts = "zohoProcessingGetAccounts",
    ZohoOnSaveVendorAccountMap = "onZohoSaveVendorAccountMap",
    ZohoOnUseGrantToken = "onZohoUseGrantToken",
    ZohoSaveVendorAccountMap = "zohoSaveVendorAccountMap",
    ZohoUseGrantToken = "zohoUseGrantToken",
    QBOPullEstimates = "qboPullEstimates",
    QBOOnPullEstimates = "onQboPullEstimates",
    TokenGetSalesReps = "getSalesReps",
    TokenOnGetSalesReps = "onGetSalesReps",
    QBOPullCustomersStart = "QBOPullCustomersStart",
    QBOPullCustomersUpdate = "QBOPullCustomersUpdate",
    CatalogItemProcessLot = "processLot",
    CatalogItemOnProcessLot = "onProcessLot",
    CatalogItemGetLots = "getLots",
    CatalogItemOnGetLots = "onGetLots",
    StripeGetLatestInvoiceUrl = "stripeGetLatestInvoiceUrl",
    StripeOnGetLatestInvoiceUrl = "onStripeGetLatestInvoiceUrl",
    StripePaymentSucceeded = "stripePaymentSucceeded",
    GoogleStartOAuth = "googleStartOAuth",
    GoogleOnStartOAuth = "onGoogleStartOAuth",
    GoogleDisconnectOAuth = "googleDisconnectOAuth",
    GoogleOnDisconnectOAuth = "onGoogleDisconnectOAuth",
    GoogleInitDrive = "googleInitDrive",
    GoogleOnInitDrive = "onGoogleInitDrive",
    QBDPushItems = "qbdPushItems",
    QBDOnPushItems = "onQBDPushItems",
    QBDPushCustomers = "qbdPushCustomers",
    QBDOnPushCustomers = "onQBDPushCustomers",
    OrderEntryBulkQuoteConvert = "bulkQuoteConvert",
    OrderEntryOnBulkQuoteConvert = "onBulkQuoteConvert",
    OrderEntryBulkQuoteConvertStart = "bulkQuoteConvertStart",
    QBOPushCatalogItems = "qboPushCatalogItems",
    QBOOnPushCatalogItems = "onQBOPushCatalogItems",
    QBOGetOtherCurrentAssetAccounts = "qboGetOtherCurrentAssetAccounts",
    QBOOnGetOtherCurrentAssetAccounts = "onQBOGetOtherCurrentAssetAccounts",
    QBOGetAccounts = "qboGetAccounts",
    QBOOnGetAccounts = "onQBOGetAccounts",
    VendorsGetVendorCsv = "getVendorCSV",
    VendorsOnGetVendorCsv = "onGetVendorCSV",
    PaymentsGetCards = "getCards",
    PaymentsOnGetCards = "onGetCards",
    PaymentsCreateCardFromToken = "createCardFromToken",
    PaymentsOnCreateCardFromToken = "onCreateCardFromToken",
    PaymentsDeleteACard = "deleteACard",
    PaymentsOnDeleteACard = "onDeleteACard",
    PaymentsCreateACharge = "createACharge",
    PaymentsOnCreateACharge = "onCreateACharge",
    OrderEntryPerformInventoryCheck = "performInventoryCheck",
    OrderEntryOnPerformInventoryCheck = "onPerformInventoryCheck",
    FishbowlCreateSalesOrders = "fishbowlCreateSalesOrders",
    FishbowlOnCreateSalesOrders = "onFishbowlCreateSalesOrders",
    FishbowlConnect = "fishbowlConnect",
    FishbowlOnConnect = "onFishbowlConnect",
    FishbowlPullCatalogItems = "fishbowlPullCatalogItems",
    FishbowlOnPullCatalogItems = "onFishbowlPullCatalogItems",
    FishbowlPullCustomers = "fishbowlPullCustomers",
    FishbowlOnPullCustomers = "onFishbowlPullCustomers",
    // FishbowlOnLogout = "onFishbowlLogout",
    // FishbowlLogout = "fishbowlLogout",
    OrderCreateBackorder = "createBackorder",
    OrderOnCreateBackorder = "onCreateBackorder",
    UserUpdateUserSettings = "updateUserSettings",
    UserOnUpdateUserSettings = "onUpdateUserSettings",
    RepGroupGetRepGroups = "getRepGroups",
    RepGroupOnGetRepGroups = "onGetRepGroups",
    RepGroupGetRepGroup = "getRepGroup",
    RepGroupOnGetRepGroup = "onGetRepGroup",
    RepGroupProcessRepGroup = "processRepGroup",
    RepGroupOnProcessRepGroup = "onProcessRepGroup",
    RepGroupGetSalesReps = "getSalesRepsDetails",
    RepGroupOnGetSalesReps = "onGetSalesRepsDetails",
    RepGroupProcessSalesRep = "processSalesRep",
    RepGroupOnProcessSalesRep = "onProcessSalesRep",
    PurchaseOrderGetVendorSourceLocations = "getVendorSourceLocations",
    PurchaseOrderOnGetVendorSourceLocations = "onGetVendorSourceLocations",
    PurchaseOrderProcessVendorSourceLocation = "processVendorSourceLocation",
    PurchaseOrderOnProcessVendorSourceLocation = "onProcessVendorSourceLocation",
    PurchaseOrderGetVendorSourcesByCategory = "getVendorSourcesByCategory",
    PurchaseOrderOnGetVendorSourcesByCategory = "onGetVendorSourcesByCategory",
    TakeOffGetTakeOffs = "getTakeOffs",
    TakeOffOnGetTakeOffs = "onGetTakeOffs",
    TakeOffProcessTakeOff = "processTakeOff",
    TakeOffOnProcessTakeOff = "onProcessTakeOff",
    TakeOffGetTakeOffOrder = "getTakeOffOrder",
    TakeOffOnGetTakeOffOrder = "onGetTakeOffOrder",
    TakeOffProcessTakeOffOrder = "processTakeOffOrder",
    TakeOffOnProcessTakeOffOrder = "onProcessTakeOffOrder",
    TakeOffProcessTakeOffOrderCategory = "processTakeOffOrderCategory",
    TakeOffOnProcessTakeOffOrderCategory = "onProcessTakeOffOrderCategory",
    TakeOffProcessTakeOffOrderItem = "processTakeOffOrderItem",
    TakeOffOnProcessTakeOffOrderItem = "onProcessTakeOffOrderItem",
    FishbowlGetLocationGroups = "fishbowlGetLocationGroups",
    FishbowlOnGetLocationGroups = "fishbowlOnGetLocationGroups",
    FishbowlGetUsers = "fishbowlGetUsers",
    FishbowlOnGetUsers = "fishbowlOnGetUsers",
    LMCGetTruckOptions = "lmcGetTruckOptions",
    LMCOnGetTruckOptions = "lmcOnGetTruckOptions",
    LMCProcessTruckOption = "lmcProcessTruckOption",
    LMCOnProcessTruckOption = "lmcOnProcessTruckOption",
    LMCProcessCustomSchedule = "lmcProcessCustomSchedule",
    LMCOnProcessCustomSchedule = "lmcOnProcessCustomSchedule",
    PurchaseOrderGetVendorSourcesCSV = "getVendorSourcesCSV",
    PurchaseOrderOnGetVendorSourcesCSV = "onGetVendorSourcesCSV",
    PurchaseOrderProcessVendorSourcesCSV = "processVendorSourcesCSV",
    PurchaseOrderOnProcessVendorSourcesCSV = "onProcessVendorSourcesCSV",
    PurchaseOrderGetVendorSourcesLocationsCSV = "getVendorSourcesLocationsCSV",
    PurchaseOrderOnGetVendorSourcesLocationsCSV = "onGetVendorSourcesLocationsCSV",
    PurchaseOrderProcessVendorSourcesLocationsCSV = "processVendorSourcesLocationsCSV",
    PurchaseOrderOnProcessVendorSourcesLocationsCSV = "onProcessVendorSourcesLocationsCSV",
    PurchaseOrderGetVendorSourcesCatalogItemsCSV = "getVendorSourcesCatalogItemsCSV",
    PurchaseOrderOnGetVendorSourcesCatalogItemsCSV = "onGetVendorSourcesCatalogItemsCSV",
    PurchaseOrderProcessVendorSourcesCatalogItemsCSV = "processVendorSourcesCatalogItemsCSV",
    PurchaseOrderOnProcessVendorSourcesCatalogItemsCSV = "onProcessVendorSourcesCatalogItemsCSV",
    QBOGetLatestInvoiceDetails = "qboGetLatestInvoiceDetails",
    QBOOnGetLatestInvoiceDetails = "qboOnGetLatestInvoiceDetails",
    TaxJarSaveApiKey = "taxJarSaveAPIKey",
    TaxJarOnSaveApiKey = "taxJarOnSaveAPIKey",
    TaxJarCalculateSalesTax = "taxJarCalculateSalesTax",
    TaxJarOnCalculateSalesTax = "taxJarOnCalculateSalesTax",
    TokenProcessParentVendorToken = "processParentVendorToken",
    TokenOnProcessParentVendorToken = "onProcessParentVendorToken",
    QBOConnectCatalogItems = "qboConnectCatalogItems",
    QBOOnConnectCatalogItems = "onQboConnectCatalogItems",
    QBOVoidInvoice = "qboVoidInvoice",
    QBOOnVoidInvoice = "onQboVoidInvoice",
    QBODeleteInvoice = "qboDeleteInvoice",
    QBOOnDeleteInvoice = "onQboDeleteInvoice",
    CatalogsDuplicateCatalog = "catalogsDuplicateCatalog",
    CatalogsOnDuplicateCatalog = "onCatalogsDuplicateCatalog",
    ReportGetTotalLogins = "getTotalLoginsReport",
    ReportOnGetTotalLogins = "onGetTotalLoginsReport",
    ShipstationListWarehouses = "shipstationListWarehouses",
    ShipstationOnListWarehouses = "onShipstationListWarehouses",
    SuppliersCreateSupplierUsersCsv = "createSupplierUsersCsv",
    SuppliersOnCreateSupplierUsersCsv = "onCreateSupplierUsersCsv",
    SuppliersProcessSupplierUsersCsv = "processSupplierUsersCsv",
    SuppliersOnProcessSupplierUsersCsv = "onProcessSupplierUsersCsv",
    PurchaseOrderGetVendorSourceLocationItemsByCategory = "getVendorSourceLocationItemsByCategory",
    PurchaseOrderOnGetVendorSourceLocationItemsByCategory = "onGetVendorSourceLocationItemsByCategory",
    QBDGetStoredData = "qbdGetStoredData",
    QBDOnGetStoredData = "onQbdGetStoredData",
    OrderDeleteBatchOrders = "deleteBatchOrders",
    OrderOnDeleteBatchOrders = "onDeleteBatchOrders",
    VendorsRevoke = "revokeVendor",
    VendorsOnRevoke = "onRevokeVendor",
    SuppliersGetApiKeys = "getApiKeys",
    SuppliersOnGetApiKeys = "onGetApiKeys",
    SuppliersProcessApiKey = "processApiKey",
    SuppliersOnProcessApiKey = "onProcessApiKey",
    ReportProductSearchesByCustomer = "reportProductSearchesByCustomer",
    ReportOnProductSearchesByCustomer = "onReportProductSearchesByCustomer",
    ReportGetOrdersInPeriodByStatus = "reportGetOrdersInPeriodByStatus",
    ReportOnGetOrdersInPeriodByStatus = "onReportGetOrdersInPeriodByStatus",
    ReportGetOrdersByProductByCustomer = "reportGetOrdersByProductByCustomer",
    ReportOnGetOrdersByProductByCustomer = "onReportGetOrdersByProductByCustomer",
    OrderGetOrderBatchPDF = "getOrderBatchPDF",
    OrderOnGetOrderBatchPDF = "onGetOrderBatchPDF",
    TakeOffGetTakeOffCsv = "getTakeOffCsv",
    TakeOffOnGetTakeOffCsv = "onGetTakeOffCsv",
    TakeOffUploadTakeOffCsv = "uploadTakeOffCsv",
    TakeOffOnUploadTakeOffCsv = "onUploadTakeOffCsv",
    TokenAdminResetUserPassword = "tokenAdminResetUserPassword",
    TokenOnAdminResetUserPassword = "onTokenAdminResetUserPassword",
    AdminPullTaxJarCategories = "adminPullTaxJarCategories",
    AdminOnPullTaxJarCategories = "onAdminPullTaxJarCategories",
    TaxJarGetTaxCategories = "taxJarGetTaxCategories",
    TaxJarOnGetTaxCategories = "onTaxJarGetTaxCategories",
    AmazonGetAuthUrl = "amazonGetAuthUrl",
    AmazonOnGetAuthUrl = "amazonOnGetAuthUrl",
    AmazonDisconnect = "amazonDisconnect",
    AmazonOnDisconnect = "amazonOnDisconnect",
    OpenCartConnect = "openCartConnect",
    OpenCartOnConnect = "openCartOnConnect",
    OpenCartPullOrders = "openCartPullOrders",
    OpenCartOnPullOrders = "openCartOnPullOrders",
    TakeOffConvertToOrder = "takeOffConvertToOrder",
    TakeOffOnConvertToOrder = "takeOffOnConvertToOrder",
    OpenCartConnectExistingCatalogItems = "openCartConnectExistingCatalogItems",
    OpenCartOnConnectExistingCatalogItems = "openCartOnConnectExistingCatalogItems",
    OpenCartPushCatalogItems = "openCartPushCatalogItems",
    OpenCartOnPushCatalogItems = "openCartOnPushCatalogItems",
    RepGroupProcessAssignedVendors = "repGroupProcessAssignedVendors",
    RepGroupOnProcessAssignedVendors = "repGroupOnProcessAssignedVendors",
    QBOPushCustomers = "qboPushCustomers",
    QBOOnPushCustomers = "qboOnPushCustomers",
    DiscountsGetDiscounts = "getDiscounts",
    DiscountsOnGetDiscounts = "onGetDiscounts",
    DiscountsProcessDiscount = "processDiscount",
    DiscountsOnProcessDiscount = "onProcessDiscount",
    DiscountGetDiscountsTypeahead = "getDiscountsTypeahead",
    DiscountOnGetDiscountsTypeahead = "onGetDiscountsTypeahead",
    QBDSyncCatalogItemsStart = "qbdSyncCatalogItemsStart",
    QBDSyncCatalogItemsUpdate = "qbdSyncCatalogItemsUpdate",
    QBDSyncCatalogItemsProcessing = "qbdSyncCatalogItemsProcessing",
    QBOPushCustomersStart = "qboPushCustomersStart",
    QBOPushCustomersUpdate = "qboPushCustomersUpdate",
    ReportAverageSalesByCustomer = "reportAverageSalesByCustomer",
    ReportOnAverageSalesByCustomer = "onReportAverageSalesByCustomer",
    ReportCurrentSalesDetailsByUser = "reportCurrentSalesDetailsByUser",
    ReportOnCurrentSalesDetailsByUser = "onReportCurrentSalesDetailsByUser",
    DashboardProcessDashboard = "processDashboard",
    DashboardOnProcessDashboard = "onProcessDashboard",
    DashboardGetDashboards = "getDashboards",
    DashboardOnGetDashboards = "onGetDashboards",
    OrderCreateOrderBatch = "createOrderBatch",
    OrderOnCreateOrderBatch = "onCreateOrderBatch",
    AppLoadUser = "loadUser",
    AppOnLoadUser = "onLoadUser",
    PurchaseOrderDownloadPurchaseOrderPdf = "downloadPurchaseOrderPdf",
    PurchaseOrderOnDownloadPurchaseOrderPdf = "onDownloadPurchaseOrderPdf",
    TaxJarCreateOrders = "taxJarCreateOrders",
    TaxJarOnCreateOrders = "onTaxJarCreateOrders",
    TaxJarUpdateOrders = "taxJarUpdateOrders",
    TaxJarOnUpdateOrders = "onTaxJarUpdateOrders",
    AccountingGetAccounting = "getAccounting",
    AccountingOnGetAccounting = "onGetAccounting",
    AccountingProcessAccounting = "processAccounting",
    AccountingOnProcessAccounting = "onProcessAccounting",
    AccountingGenerateExcelFile = "accountingGenerateExcelFile",
    AccountingOnGenerateExcelFile = "onAccountingGenerateExcelFile",
    ShipstationVoidLabels = "shipstationVoidLabels",
    ShipstationOnVoidLabels = "shipstationOnVoidLabels",
    Connected = "clientConnected",
    PickListGetPickListItem = "getPickListItem",
    PickListOnGetPickListItem = "onGetPickListItem",
    PickListUpdatePickListItem = "updatePickListItem",
    PickListOnUpdatePickListItem = "onUpdatePickListItem",
    PickListProcessLot = "pickListProcessLot",
    PickListOnProcessLot = "onPickListProcessLot",
    UserLeaveRoom = "userLeaveRoom",
    UserOnLeaveRoom = "onUserLeaveRoom",
    OrderGetBulkImportQueue = "getBulkImportQueue",
    OrderOnGetBulkImportQueue = "onGetBulkImportQueue",
    CategoriesTypeaheadGetCategories = "categoriesTypeaheadGetCategories",
    CategoriesOnTypeaheadGetCategories = "onCategoriesTypeaheadGetCategories",
    ShipmentGetShippingWeightTiers = "getShippingWeightTiers",
    ShipmentOnGetShippingWeightTiers = "onGetShippingWeightTiers",
    ShipmentProcessShippingWeightTiers = "processShippingWeightTiers",
    ShipmentOnProcessShippingWeightTiers = "onProcessShippingWeightTiers",
    ShipmentGetShippingZones = "getShippingZones",
    ShipmentOnGetShippingZones = "onGetShippingZones",
    ShipmentProcessShippingZones = "processShippingZones",
    ShipmentOnProcessShippingZones = "onProcessShippingZones",
    ShipmentGetShippingOrderTotalTiers = "getShippingOrderTotalTiers",
    ShipmentOnGetShippingOrderTotalTiers = "onGetShippingOrderTotalTiers",
    ShipmentProcessShippingOrderTotalTiers = "processShippingOrderTotalTiers",
    ShipmentOnProcessShippingOrderTotalTiers = "onProcessShippingOrderTotalTiers",
    PurchaseOrderProcessVendorSourceCatalogItem = "processVendorSourceCatalogItem",
    PurchaseOrderOnProcessVendorSourceCatalogItem = "onProcessVendorSourceCatalogItem",
    PurchaseOrderGetPurchaseOrderDetailForOrder = "getPurchaseOrderDetailForOrder",
    PurchaseOrderOnGetPurchaseOrderDetailForOrder = "onGetPurchaseOrderDetailForOrder",
    PurchaseOrderCreatePurchaseOrdersFromOrder = "createPurchaseOrdersFromOrder",
    PurchaseOrderOnCreatePurchaseOrdersFromOrder = "onCreatePurchaseOrdersFromOrder",
    OrderEmailQuote = "emailQuote",
    OrderOnEmailQuote = "onEmailQuote",
    TaxJarUpdateNexusRegions = "updateTaxJarNexusRegions",
    TaxJarOnUpdateNexusRegions = "onUpdateTaxJarNexusRegions",
    TaxJarGetNexusRegions = "getTaxJarNexusRegions",
    TaxJarOnGetNexusRegions = "onGetTaxJarNexusRegions",
    MaterialBulkImportCSV = "materialBulkImportCSV",
    MaterialOnBulkImportCSV = "onMaterialBulkImportCSV",
    MaterialGetBulkImportCSV = "materialGetBulkImportCSV",
    MaterialOnGetBulkImportCSV = "onMaterialGetBulkImportCSV",
    MaterialsBulkImportCsvProgress = "materialsBulkImportCsvProgress",
    MaterialsGetCatalogItemTemplate = "materialsGetCatalogItemTemplate",
    MaterialsOnGetCatalogItemTemplate = "onMaterialsGetCatalogItemTemplate",
    FishbowlPullCustomersProgress = "fishbowlPullCustomersProgress",
    QBOPullAndDownloadCustomers = "qboPullAndDownloadCustomers",
    QBOOnPullAndDownloadCustomers = "onQboPullAndDownloadCustomers",
    ShipmentGroupCaptureSignature = "shipmentGroupCaptureSignature",
    ShipmentGroupOnCaptureSignature = "onShipmentGroupCaptureSignature",
    FishbowlPullShipments = "fishbowlPullShipments",
    FishbowlOnPullShipments = "onFishbowlPullShipments",
    FishbowlCreateQueueItem = "fishbowlCreateQueueItem",
    FishbowlOnCreateQueueItem = "onFishbowlCreateQueueItem",
    FishbowlQueueRunningCheck = "fishbowlQueueRunningCheck",
    FishbowlOnQueueRunningCheck = "onFishbowlQueueRunningCheck",
    FishbowlGetQueue = "fishbowlGetQueue",
    FishbowlOnGetQueue = "onFishbowlGetQueue",
    ReportVendorActivityReport = "vendorActivityReport",
    ReportOnVendorActivityReport = "onVendorActivityReport",
    OrderGenerateQuotePDF = "generateQuotePDF",
    OrderOnGenerateQuotePDF = "onGenerateQuotePDF",
    OrderGenerateOrderPDF = "generateOrderPDF",
    OrderOnGenerateOrderPDF = "onGenerateOrderPDF",
    QBOPullAndDownloadCatalogItems = "qboPullAndDownloadCatalogItems",
    QBOOnPullAndDownloadCatalogItems = "qboOnPullAndDownloadCatalogItems",
    SuppliersProcessBrandedLogin = "processBrandedLogin",
    SuppliersOnProcessBrandedLogin = "onProcessBrandedLogin",
    SuppliersGetBrandedLogin = "getBrandedLogin",
    SuppliersOnGetBrandedLogin = "onGetBrandedLogin",
    SuppliersCreateBrandedLoginSubDomain = "createBrandedLoginSubDomain",
    SuppliersOnCreateBrandedLoginSubDomain = "onCreateBrandedLoginSubDomain",
    OrderUpdateOrderCardToUse = "orderUpdateCardToUse",
    OrderOnUpdateOrderCardToUse = "onOrderUpdateCardToUse",
    CatalogReconcilePriceGroups = "reconcilePriceGroups",
    CatalogOnReconcilePriceGroups = "onReconcilePriceGroups",
    OrderGetOrderTimeline = "getOrderTimeline",
    OrderOnGetOrderTimeline = "onGetOrderTimeline",
    PaymentsGetPaymentDetails = "getPaymentDetails",
    PaymentsOnGetPaymentDetails = "onGetPaymentDetails",
    PaymentsVoidCharge = "paymentVoidCharge",
    PaymentsOnVoidCharge = "onPaymentVoidCharge",
    PaymentsRefundCharge = "paymentRefundCharge",
    PaymentsOnRefundCharge = "onPaymentRefundCharge",
    LmcGetDealersData = "lmcGetDealersData",
    LmcOnGetDealersData = "onLmcGetDealersData",
    ReportItemInOrdersReport = "itemInOrdersReport",
    ReportOnItemInOrdersReport = "onItemInOrdersReport",
    XeroOauthStart = "XeroOauthStart",
    XeroOnAuthStart = "onXeroOauthStart",
    XeroGetContacts = "XeroGetContacts",
    XeroOnGetContacts = "onXeroGetContacts",
    XeroGetContactsProgress = "XeroGetContactsProgress",
    XeroDisconnect = "XeroDisconnect",
    XeroOnDisconnect = "onXeroDisconnect",
    XeroGetItems = "XeroGetItems",
    XeroOnGetItems = "onXeroGetItems",
    XeroGetItemsProgress = "XeroGetItemsProgress",
    XeroCreateInvoice = "XeroCreateInvoice",
    XeroOnCreateInvoice = "onXeroCreateInvoice",
    XeroGetInvoicePdf = "XeroGetInvoicePdf",
    XeroOnGetInvoicePdf = "onXeroGetInvoicePdf",
    XeroEmailInvoice = "XeroEmailInvoice",
    XeroOnEmailInvoice = "onXeroEmailInvoice",
    XeroDeleteInvoice = "XeroDeleteInvoice",
    XeroOnDeleteInvoice = "onXeroDeleteInvoice",
    XeroVoidInvoice = "XeroVoidInvoice",
    XeroOnVoidInvoice = "onXeroVoidInvoice",
    CatalogDeduplicate = "catalogDeduplicate",
    CatalogOnDeduplicate = "onCatalogDeduplicate",
    CatalogReconcileVendors = "reconcileCatalogVendors",
    CatalogOnReconcileVendors = "onReconcileCatalogVendors",
    QBDCreateWarehouses = "qbdCreateWarehouses",
    QBDOnCreateWarehouses = "onQbdCreateWarehouses",
    OrderCopyToDiffCatalog = "copyToDiffCatalog",
    OrderOnCopyToDiffCatalog = "onCopyToDiffCatalog",
    OrderValidateCopyToDiffCatalog = "validateCopyToDiffCatalog",
    OrderOnValidateCopyToDiffCatalog = "onValidateCopyToDiffCatalog",
    OrderCopyToDiffCatalogProgress = "validateCopyToDiffCatalogProgress",
    QBOGetClasses = "qboGetClasses",
    QBOOnGetClasses = "qboOnGetClasses",
    OrderCancelOrder = "cancelOrder",
    OrderOnCancelOrder = "onCancelOrder",
    OrderDeallocateInventory = "deallocateInventory",
    OrderOnDeallocateInventory = "onDeallocateInventory",
    QBOGetTaxRates = "qboGetTaxRates",
    QBOOnGetTaxRates = "onQboGetTaxRates",
    QBOCreateEstimate = "qboCreateEstimate",
    QBOOnCreateEstimate = "onQboCreateEstimate",
    QBOGetPDFEstimate = "qboGetPdfEstimate",
    QBOOnGetPDFEstimate = "onQboGetPdfEstimate",
    QBODeleteEstimate = "qboDeleteEstimate",
    QBOOnDeleteEstimate = "onQboDeleteEstimate",
    QBOSendEstimate = "qboSendEstimate",
    QBOOnSendEstimate = "onQboSendEstimate",
    QBOGetPDFPurchaseOrder = "qboGetPdfPurchaseOrder",
    QBOOnGetPDFPurchaseOrder = "onQboGetPdfPurchaseOrder",
    QBOSendPurchaseOrder = "qboSendPurchaseOrder",
    QBOOnSendPurchaseOrder = "onQboSendPurchaseOrder",
    QBODeletePurchaseOrder = "qboDeletePurchaseOrder",
    QBOOnDeletePurchaseOrder = "onQboDeletePurchaseOrder",
    QBOCreatePurchaseOrder = "qboCreatePurchaseOrder",
    QBOOnCreatePurchaseOrder = "onQboCreatePurchaseOrder",
    QBOPullVendors = "qboPullVendors",
    QBOOnPullVendors = "onQboPullVendors",
    CatalogItemGetDeletedCatalogItems = "getDeletedCatalogItems",
    CatalogItemOnGetDeletedCatalogItems = "onGetDeletedCatalogItems",
    OrderUpdateMetaData = "orderUpdateMetaData",
    OrderOnUpdateMetaData = "onOrderUpdateMetaData",
    OrderGenerateBulkOrderPDF = "generateBulkOrderPDF",
    OrderOnGenerateBulkOrderPDF = "onGenerateBulkOrderPDF",
    CatalogGetImagesCSV = "catalogGetImagesCsv",
    CatalogOnGetImagesCSV = "onCatalogGetImagesCsv",
    WayfairTestConnection = "wayfairTestConnection",
    WayfairOnTestConnection = "onWayfairTestConnection",
    WayfairPullPurchaseOrders = "wayfairPullPurchaseOrders",
    WayfairOnPullPurchaseOrders = "onWayfairPullPurchaseOrders",
    WayfairAcknowledgePurchaseOrder = "wayfairAcknowledgePurchaseOrder",
    WayfairOnAcknowledgePurchaseOrder = "onWayfairAcknowledgePurchaseOrder",
    AutomationGetAutomations = "getAutomations",
    AutomationOnGetAutomations = "onGetAutomations",
    QBOConnectAllCustomers = "qboConnectAllCustomers",
    QBOOnConnectAllCustomers = "onQboConnectAllCustomers",
    QBOConnectAllCustomersProgress = "qboConnectAllCustomersProgress",
    PaymentsGetCard = "paymentsGetCard",
    PaymentsOnGetCard = "onPaymentsGetCard",
    WayfairAcknowledgeShippingForPurchaseOrder = "wayfairAcknowledgeShippingForPurchaseOrder",
    WayfairOnAcknowledgeShippingForPurchaseOrder = "onWayfairAcknowledgeShippingForPurchaseOrder",
    WayfairConnectCatalogItems = "wayfairConnectCatalogItems",
    WayfairOnConnectCatalogItems = "onWayfairConnectCatalogItems",
    SuppliersCompleteOnboarding = "suppliersCompleteOnboarding",
    SuppliersOnCompleteOnboarding = "onSuppliersCompleteOnboarding",
    ZenDeskCreateTicket = "zenDeskCreateTicket",
    ZenDeskOnCreateTicket = "onZenDeskCreateTicket",
    WayfairInventoryUpdate = "wayfairInventoryUpdate",
    WayfairOnInventoryUpdate = "onWayfairInventoryUpdate",
    WayfairGetLogs = "wayfairGetLogs",
    WayfairOnGetLogs = "onWayfairGetLogs",
    WayfairGetPackingSlip = "wayfairGetPackingSlip",
    WayfairOnGetPackingSlip = "onWayfairGetPackingSlip",
    WayfairGetShippingLabels = "wayfairGetShippingLabels",
    WayfairOnGetShippingLabels = "onWayfairGetShippingLabels",
    WayfairGetBillOfLading = "wayfairGetBillOfLading",
    WayfairOnGetBillOfLading = "onWayfairGetBillOfLading",
    QBOGetPreferences = "qboGetPreferences",
    QBOOnGetPreferences = "onQboGetPreferences",
    FishbowlDownloadCustomerCsv = "fishbowlDownloadCustomerCsv",
    FishbowlOnDownloadCustomerCsv = "onFishbowlDownloadCustomerCsv",
    FishbowlDownloadCatalogItemsCsv = "fishbowlDownloadCatalogItemsCsv",
    FishbowlOnDownloadCatalogItemsCsv = "onFishbowlDownloadCatalogItemsCsv",
    UserCompleteOnboarding = "userCompleteOnboarding",
    UserOnCompleteOnboarding = "onUserCompleteOnboarding",
    SpsCommerceGetAuthorizeUrl = "spsCommerceGetAuthorizeUrl",
    SpsCommerceOnGetAuthorizeUrl = "onSpsCommerceGetAuthorizeUrl",
    VendorsGetVendorsByGuid = "getVendorsByGuid",
    VendorsOnGetVendorsByGuid = "onGetVendorsByGuid",
    SpsCommerceFilterTransactions = "spsCommerceFilterTransactions",
    SpsCommerceOnFilterTransactions = "onSpsCommerceFilterTransactions",
    SpsCommerceDisconnect = "spsCommerceDisconnect",
    SpsCommerceOnDisconnect = "onSpsCommerceDisconnect",
    SpsCommerceCreateTransaction = "spsCommerceCreateTransaction",
    SpsCommerceOnCreateTransaction = "onSpsCommerceCreateTransaction",
    SpsCommerceGetTransaction = "spsCommerceGetTransaction",
    SpsCommerceOnGetTransaction = "onSpsCommerceGetTransaction",
    SpsCommerceDeleteTransaction = "spsCommerceDeleteTransaction",
    SpsCommerceOnDeleteTransaction = "onSpsCommerceDeleteTransaction",
    SpsCommerceViewTransactionHistory = "spsCommerceViewTransactionHistory",
    SpsCommerceOnViewTransactionHistory = "onSpsCommerceViewTransactionHistory",
    FedExCreateShipment = "fedexCreateShipment",
    FedExOnCreateShipment = "onFedexCreateShipment",
    FedExCancelShipment = "fedexCancelShipment",
    FedExOnCancelShipment = "onFedexCancelShipment",
    FedExRetrieveAsyncShipment = "fedexRetrieveAsyncShipment",
    FedExOnRetrieveAsyncShipment = "onFedexRetrieveAsyncShipment",
    FedExValidateShipment = "fedexValidateShipment",
    FedExOnValidateShipment = "onFedexValidateShipment",
    FedExCreateTag = "fedexCreateTag",
    FedExOnCreateTag = "onFedexCreateTag",
    FedExCancelTag = "fedexCancelTag",
    FedExOnCancelTag = "onFedexCancelTag",
    OrderGetMinimumOrder = "orderGetMinimumOrder",
    OrderOnGetMinimumOrder = "onOrderGetMinimumOrder",
    ContactsGetContacts = "getContacts",
    ContactsOnGetContacts = "onGetContacts",
    ZohoGetConnectionDetail = "zohoGetConnectionDetail",
    ZohoOnGetConnectionDetail = "onZohoGetConnectionDetail",
    OrderEntrySubmitOrder = "orderEntrySubmitOrder",
    OrderEntryOnSubmitOrder = "onOrderEntrySubmitOrder",
    ShipmentGetBillOfLading = "getBillOfLading",
    ShipmentOnGetBillOfLading = "onGetBillOfLading",
    SuppliersGetUsers = "suppliersGetUsers",
    SuppliersOnGetUsers = "onSuppliersGetUsers",
    QBOQueueCreateInvoices = "qboQueueCreateInvoices",
    QBOOnQueueCreateInvoices = "qboOnQueueCreateInvoices",
    HubspotStartOauth = "hubspotStartOAuth",
    HubspotOnStartOauth = "onHubspotStartOAuth",
    ContactsCreateContact = "createContact",
    ContactsOnCreateContact = "onCreateContact",
    ContactsDeleteContact = "deleteContact",
    ContactsOnDeleteContact = "onDeleteContact",
    ContactsUpdateContact = "updateContact",
    ContactsOnUpdateContact = "onUpdateContact",
    ShopifyDownloadProductCsv = "shopifyDownloadProductCsv",
    ShopifyOnDownloadProductCsv = "onShopifyDownloadProductCsv",
    ShopifySyncProductsProgress = "shopifySyncProductsProgress",
    HubspotPullCompanies = "hubspotPullCompanies",
    HubspotOnPullCompanies = "onHubspotPullCompanies",
    HubspotDisconnect = "hubspotDisconnect",
    HubspotOnDisconnect = "onHubspotDisconnect",
    HubspotPullCompaniesProgress = "hubspotPullCompaniesProgress",
    OrderGetTemplatesForAccount = "orderGetTemplatesForAccount",
    OrderOnGetTemplatesForAccount = "onOrderGetTemplatesForAccount",
    CartAddItem = "cartAddItem",
    CartOnAddItem = "cartOnAddItem",
    CartUpdateItem = "cartUpdateItem",
    CartOnUpdateItem = "onCartUpdateItem",
    CartDeleteItem = "cartDeleteItem",
    CartOnDeleteItem = "onCartDeleteItem",
    CartGetCart = "getCart",
    CartOnGetCart = "onGetCart",
    CartCreatePayment = "cartCreatePayment",
    CartOnCreatePayment = "onCartCreatePayment",
    CartCreatePaymentIntent = "cartCreatePaymentIntent",
    CartOnCreatePaymentIntent = "onCartCreatePaymentIntent",
    CartUpdatePaymentIntent = "cartUpdatePaymentIntent",
    CartOnUpdatePaymentIntent = "onCartUpdatePaymentIntent",
    CartUpdateShipTo = "cartUpdateShipTo",
    CartOnUpdateShipTo = "onCartUpdateShipTo",
    CartValidateInventory = "cartValidateInventory",
    CartOnValidateInventory = "onCartValidateInventory",
    CartGetCartByGuid = "getCartByGuid",
    CartOnGetCartByGuid = "onGetCartByGuid",
    OrderGetCartOrders = "getCartOrders",
    OrderOnGetCartOrders = "onGetCartOrders",
    CatalogItemGetChildItems = "catalogItemGetChildItems",
    CatalogItemOnGetChildItems = "catalogItemOnGetChildItems",
    PurchaseOrderGetCatalogItemVendorSources = "getCatalogItemVendorSources",
    PurchaseOrderOnGetCatalogItemVendorSources = "onGetCatalogItemVendorSources",
    PurchaseOrderGetVendorSourcesForOrderItems = "getVendorSourcesForOrderItems",
    PurchaseOrderOnGetVendorSourcesForOrderItems = "onGetVendorSourcesForOrderItems",
    EasyShipRequestRates = "easyShipRequestRates",
    EasyShipOnRequestRates = "onEasyShipRequestRates",
    EasyShipCreateShipment = "easyShipCreateShipment",
    EasyShipOnCreateShipment = "onEasyShipCreateShipment",
    EasyShipUpdateShipment = "easyShipUpdateShipment",
    EasyShipOnUpdateShipment = "onEasyShipUpdateShipment",
    EasyShipGetShipment = "easyShipGetShipment",
    EasyShipOnGetShipment = "onEasyShipGetShipment",
    EasyShipListAllShipments = "easyShipListAllShipments",
    EasyShipOnListAllShipments = "onEasyShipListAllShipments",
    EasyShipBuyShipmentLabel = "easyShipBuyShipmentLabel",
    EasyShipOnBuyShipmentLabel = "onEasyShipBuyShipmentLabel",
    EasyShipDeleteShipment = "easyShipDeleteShipment",
    EasyShipOnDeleteShipment = "onEasyShipDeleteShipment",
    EasyShipListAllBoxes = "easyShipListAllBoxes",
    EasyShipOnListAllBoxes = "onEasyShipListAllBoxes",
    EasyShipListAllCouriers = "easyShipListAllCouriers",
    EasyShipOnListAllCouriers = "onEasyShipListAllCouriers",
    ZoeyPullOrders = "zoeyPullOrders",
    ZoeyOnPullOrders = "onZoeyPullOrders",
    ZoeyPullCatalogItems = "zoeyPullCatalogItems",
    ZoeyOnPullCatalogItems = "onZoeyPullCatalogItems",
    ZoeyCreateQueueItem = "zoeyCreateQueueItem",
    ZoeyOnCreateQueueItem = "onZoeyCreateQueueItem",
    TokenGetRevokedAccounts = "tokenGetRevokedAccounts",
    TokenOnGetRevokedAccounts = "onTokenGetRevokedAccounts",
    TokenRestoreAccounts = "tokenRestoreAccounts",
    TokenOnRestoreAccounts = "onTokenRestoreAccounts",
    StripeGetSubscriptionDetails = "stripeGetSubscriptionDetails",
    StripeOnGetSubscriptionDetails = "onStripeGetSubscriptionDetails",
    StripeCreateSetupIntent = "stripeCreateSetupIntent",
    StripeOnCreateSetupIntent = "onStripeCreateSetupIntent",
    StripeCreateCustomerPortalSession = "stripeCreateCustomerPortalSession",
    StripeOnCreateCustomerPortalSession = "onStripeCreateCustomerPortalSession",
    CartCompleteCheckout = "cartCompleteCheckout",
    CartOnCompleteCheckout = "onCartCompleteCheckout",
    StripeSetupSupplierWebhook = "stripeSetupSupplierWebhook",
    StripeOnSetupSupplierWebhook = "onStripeSetupSupplierWebhook",
    SupplierSetupDemoData = "supplierSetupDemoData",
    SupplierOnSetupDemoData = "onSupplierSetupDemoData",
    AutomationCreateAutomation = "createAutomation",
    AutomationOnCreateAutomation = "onCreateAutomation",
    ReportInactiveAccountReport = "inactiveAccountReport",
    ReportOnInactiveAccountReport = "onInactiveAccountReport",
    OrderEntryCreateOrderEntryItemsBySku = "createOrderEntryItemsBySku",
    OrderEntryOnCreateOrderEntryItemsBySku = "onCreateOrderEntryItemsBySku",
    QBDUomMappings = "qbdUomMappings",
    QBDOnUomMappings = "onQbdUomMappings",
    TokenGenerateVendorSourceUserToken = "generateVendorSourceUserToken",
    TokenOnGenerateVendorSourceUserToken = "onGenerateVendorSourceUserToken",
    TokenGetSupplierVendorSourceUsersTokens = "getSupplierVendorSourceUsersTokens",
    TokenOnGetSupplierVendorSourceUsersTokens = "onGetSupplierVendorSourceUsersTokens",
    OrderEntryProcessOrderShipment = "orderEntryProcessOrderShipment",
    OrderEntryOnProcessOrderShipment = "onOrderEntryProcessOrderShipment",
    OrderEntryProcessOrderItemPriceApproval = "processOrderItemPriceApproval",
    OrderEntryOnProcessOrderItemPriceApproval = "onProcessOrderItemPriceApproval",
    OrderEntryGetOrderItemPriceApprovals = "getOrderItemPriceApprovals",
    OrderEntryOnGetOrderItemPriceApprovals = "onGetOrderItemPriceApprovals",
    ReportGetAccountsByDateReport = "getAccountsByDateReport",
    ReportOnGetAccountsByDateReport = "onGetAccountsByDateReport",
    ShopifyGetShop = "shopifyGetShop",
    ShopifyOnGetShop = "shopifyOnGetShop",
    ShopifyUpdateShop = "shopifyUpdateShop",
    ShopifyOnUpdateShop = "shopifyOnUpdateShop",
    ShopifyDeleteShop = "shopifyDeleteShop",
    ShopifyOnDeleteShop = "shopifyOnDeleteShop",
    ShopifyPullLocations = "shopifyPullLocations",
    ShopifyOnPullLocations = "onShopifyPullLocations",
    WorkflowsProcessWorkflow = "processWorkflow",
    WorkflowsOnProcessWorkflow = "onProcessWorkflow",
    WorkflowsGetWorkflows = "getWorkflows",
    WorkflowsOnGetWorkflows = "onGetWorkflows",
    ShipmentGetShipmentsForOrder = "getShipmentsForOrder",
    ShipmentOnGetShipmentsForOrder = "onGetShipmentsForOrder",
    ShipmentGetSupplierShippingCarriers = "getSupplierShippingCarriers",
    ShipmentOnGetSupplierShippingCarriers = "onGetSupplierShippingCarriers",
    ReportGetOpenOrdersReport = "getOpenOrdersReport",
    ReportOnGetOpenOrdersReport = "onGetOpenOrdersReport",
    BigCommercePullOrders = "bigCommercePullOrders",
    BigCommerceOnPullOrders = "onBigCommercePullOrders",
    BigCommerceUpsertStore = "bigCommerceUpsertStore",
    BigCommerceOnUpsertStore = "onBigCommerceUpsertStore",
    BigCommerceGetStores = "bigCommerceStores",
    BigCommerceOnGetStores = "onBigCommerceStores",
    BigCommerceDeleteStore = "bigCommerceDeleteStore",
    BigCommerceOnDeleteStore = "onBigCommerceDeleteStore",
    BigCommercePullProducts = "bigCommercePullProducts",
    BigCommerceOnPullProducts = "onBigCommercePullProducts",
    FishbowlDownloadShipmentsCsv = "fishbowlDownloadShipmentsCsv",
    FishbowlOnDownloadShipmentsCsv = "onFishbowlDownloadShipmentsCsv",
    BigCommercePushInventoryLevels = "bigCommercePushInventoryLevels",
    BigCommerceOnPushInventoryLevels = "onBigCommercePushInventoryLevels",
    BigCommercePullProductsUpdate = "bigCommercePullProductsUpdate",
    OrderRecalculateTotals = "orderRecalculateTotals",
    OrderOnRecalculateTotals = "onOrderRecalculateTotals",
    QBDResetQueue = "qbdResetQueue",
    QBDOnResetQueue = "qbdOnResetQueue",
    CartUpdateProp = "cartUpdateProp",
    CartOnUpdateProp = "onCartUpdateProp",
    DashboardDownloadData = "dashboardDownloadData",
    DashboardOnDownloadData = "onDashboardDownloadData",
    ReportGetReports = "reportGetReports",
    ReportOnGetReports = "reportOnGetReports",
    ReportCreateReport = "reportCreateReport",
    ReportOnCreateReport = "reportOnCreateReport",
    ReportGetReport = "reportGetReport",
    ReportOnGetReport = "reportOnGetReport",
    ReportGetReportProducts = "reportGetReportProducts",
    ReportOnGetReportProducts = "reportOnGetReportProducts",
    ReportDownloadExcel = "reportDownloadExcel",
    ReportOnDownloadExcel = "reportOnDownloadExcel",
    ReportProcessReport = "reportProcessReport",
    ReportOnProcessReport = "reportOnProcessReport",
    ReportFinishedProcessing = "reportFinishedProcessing",
    VendorsGetVendorUserByName = "getVendorUserByName",
    VendorsOnGetVendorUserByName = "onGetVendorUserByName",
    CatalogsGetCatalogCSVItemCategories = "getCatalogCsvItemCategories",
    CatalogsOnGetCatalogCSVItemCategories = "onGetCatalogCsvItemCategories",
    UserReleaseNewsletter = "userReleaseNewsletter",
    UserOnReleaseNewsletter = "onUserReleaseNewsletter",
    AdminGetConnectedSockets = "adminGetConnectedSockets",
    AdminOnGetConnectedSockets = "onAdminGetConnectedSockets",
    OrderEntryHoldOrder = "holdOrder",
    OrderEntryOnHoldOrder = "onHoldOrder",
    VendorGetVendorWarehouseMap = "getVendorWarehouseMap",
    VendorOnGetVendorWarehouseMap = "onGetVendorWarehouseMap",
    VendorUpdateVendorWarehouseMap = "updateVendorWarehouseMap",
    VendorOnUpdateVendorWarehouseMap = "onUpdateVendorWarehouseMap",
    DashboardGetWidgetData = "dashboardGetWidgetData",
    DashboardOnGetWidgetData = "onDashboardGetWidgetData",
    QBDGetCustomFields = "qbdGetCustomFields",
    QBDOnGetCustomFields = "onQbdGetCustomFields",
    QBDProcessCustomField = "qbdProcessCustomField",
    QBDOnProcessCustomField = "onQbdProcessCustomField",
    AdminGetStripeProducts = "adminGetStripeProducts",
    AdminOnGetStripeProducts = "onAdminGetStripeProducts",
    AdminGetStripeSubscriptions = "adminGetStripeSubscriptions",
    AdminOnGetStripeSubscriptions = "onAdminGetStripeSubscriptions",
    QBOGetOpenInvoices = "qboGetOpenInvoices",
    QBOOnGetOpenInvoices = "onQboGetOpenInvoices",
    CatalogsDeletePriceGroup = "deletePriceGroup",
    CatalogsOnDeletePriceGroup = "onDeletePriceGroup",
    ShipstationResetWebhooks = "shipstationResetWebhooks",
    ShipstationOnResetWebhooks = "onShipstationResetWebhooks",
    OrderEntryCancelOrder = "orderEntryCancelOrder",
    OrderEntryOnCancelOrder = "onOrderEntryCancelOrder",
    OrderEntryProcessSerial = "orderEntryProcessSerial",
    OrderEntryOnProcessSerial = "onOrderEntryProcessSerial",
    PackingListGenerateAveryLabels = "packingListGenerateAveryLabels",
    PackingListOnGenerateAveryLabels = "onPackingListGenerateAveryLabels",
    WarehouseProcessWarehouseTransfer = "processWarehouseTransfer",
    WarehouseOnProcessWarehouseTransfer = "onProcessWarehouseTransfer",
    WarehouseProcessWarehouseTransferItem = "processWarehouseTransferItem",
    WarehouseOnProcessWarehouseTransferItem = "onProcessWarehouseTransferItem",
    WarehouseGetTransfer = "warehouseGetTransfer",
    WarehouseOnGetTransfer = "onWarehouseGetTransfer",
    WarehouseGetTransfers = "warehouseGetTransfers",
    WarehouseOnGetTransfers = "onWarehouseGetTransfers",
    ShipmentCreateShipmentGroupAndShipmentFromOrder = "shipmentCreateShipmentGroupAndShipmentFromOrder",
    ShipmentOnCreateShipmentGroupAndShipmentFromOrder = "onShipmentCreateShipmentGroupAndShipmentFromOrder",
    SageOnlineOauthStart = "sageOnlineOauthStart",
    SageOnlineOnOauthStart = "onSageOnlineOauthStart",
    SageOnlineDisconnect = "sageOnlineDisconnect",
    SageOnlineOnDisconnect = "onSageOnlineDisconnect",
    SageOnlinePullProducts = "sageOnlinePullProducts",
    SageOnlineOnPullProducts = "onSageOnlinePullProducts",
    WarehouseAdjustWarehouseInventory = "warehouseAdjustWarehouseInventory",
    WarehouseOnAdjustWarehouseInventory = "warehouseOnAdjustWarehouseInventory",
    WarehouseMarkTransferReceived = "warehouseMarkTransferReceived",
    WarehouseOnMarkTransferReceived = "warehouseOnMarkTransferReceived",
    DashboardRefreshWidgetData = "dashboardRefreshWidgetData",
    DashboardOnRefreshWidgetData = "onDashboardRefreshWidgetData",
    DashboardWidgetDataUpdated = "dashboardWidgetDataUpdated",
    MobileDashboardGetConfig = "mobileDashboardGetConfig",
    MobileDashboardOnGetConfig = "onMobileDashboardGetConfig",
    MobileDashboardUpdateConfig = "mobileDashboardUpdateConfig",
    MobileDashboardOnUpdateConfig = "onMobileDashboardUpdateConfig",
    MobileDashboardResetConfig = "mobileDashboardResetConfig",
    MobileDashboardOnResetConfig = "onMobileDashboardResetConfig",
    CatalogItemLabelDownload = "catalogItemLabelDownload",
    CatalogItemOnLabelDownload = "onCatalogItemLabelDownload",
    CatalogItemGenerateBarcodeLabels = "catalogItemGenerateBarcodeLabels",
    CatalogItemOnGenerateBarcodeLabels = "onCatalogItemGenerateBarcodeLabels",
    ChRobinsonRatingRequest = "chRobinsonRatingRequest",
    ChRobinsonOnRatingRequest = "chRobinsonOnRatingRequest",
    ChRobinsonSaveRatingRequest = "chRobinsonSaveRatingRequest",
    ChRobinsonOnSaveRatingRequest = "chRobinsonOnSaveRatingRequest",
    QBDAccountAudit = "qbdAccountAudit",
    QBDOnAccountAudit = "onQbdAccountAudit",
    QBOSyncInvoicesUpdate = "qboSyncInvoicesUpdate",
    QBOPullInvoicesAsOrders = "qboPullInvoicesAsOrders",
    QBOOnPullInvoicesAsOrders = "onQboPullInvoicesAsOrders",
    UserUnlockAccount = "userUnlockAccount",
    UserOnUnlockAccount = "userOnUnlockAccount",
    ShipmentGetOptimizedRoute = "shipmentGetOptimizedRoute",
    ShipmentOnGetOptimizedRoute = "shipmentOnGetOptimizedRoute",
    QBDGetXML = "qbdGetXML",
    QBDOnGetXML = "onQbdGetXML",
    ReportGetCustomReports = "reportGetCustomReports",
    ReportOnGetCustomReports = "onReportGetCustomReports",
    ShipmentProcessSupplierShippingCarrier = "processSupplierShippingCarrier",
    ShipmentOnProcessSupplierShippingCarrier = "onProcessSupplierShippingCarrier",
    AddressVerifyAddress = "addressVerifyAddress",
    AddressOnVerifyAddress = "onAddressVerifyAddress",
    QBOReconcileCatalog = "qboReconcileCatalog",
    QBOOnReconcileCatalog = "onQboReconcileCatalog",
    CatalogsGetUomSets = "getUomSets",
    CatalogsOnGetUomSets = "onGetUomSets",
    CatalogsProcessUomSet = "processUomSet",
    CatalogsOnProcessUomSet = "onProcessUomSet",
    QBODownloadCreateInvoiceJson = "qboDownloadCreateInvoiceJson",
    QBOOnDownloadCreateInvoiceJson = "onQboDownloadCreateInvoiceJson",
    QBOReconcileAccounts = "qboReconcileAccounts",
    QBOOnReconcileAccounts = "onQboReconcileAccounts",
    CatalogsProcessRatioItem = "processRatioItem",
    CatalogsOnProcessRatioItem = "onProcessRatioItem",
    WooCommercePushOrder = "wooCommercePushOrder",
    WooCommerceOnPushOrder = "onWooCommercePushOrder",
    AdminRefreshCurrencyRates = "adminRefreshCurrencyRates",
    AdminOnRefreshCurrencyRates = "onAdminRefreshCurrencyRates",
    AdminUnlockUser = "adminUnlockUser",
    AdminOnUnlockUser = "onAdminUnlockUser",
    AdminSupplierLookup = "adminSupplierLookup",
    AdminOnSupplierLookup = "onAdminSupplierLookup",
    AdminResetUserPassword = "adminResetUserPassword",
    AdminOnResetUserPassword = "onAdminResetUserPassword",
    QBOPullAndDownloadVendors = "qboPullAndDownloadVendors",
    QBOOnPullAndDownloadVendors = "onQboPullAndDownloadVendors",
    SuppliersGetIntegrationProps = "supplierGetIntegrationProps",
    SuppliersOnGetIntegrationProps = "onSupplierGetIntegrationProps",
    ShopifyCreateShop = "shopifyCreateShop",
    ShopifyOnCreateShop = "onShopifyCreateShop",
    ShopifySyncCustomers = "shopifySyncCustomers",
    ShopifyOnSyncCustomers = "onShopifySyncCustomers",
    QBDGetQueueItems = "qbdGetQueueItems",
    QBDOnGetQueueItems = "onQbdGetQueueItems",
    QBDRemoveQueueItems = "qbdRemoveQueueItems",
    QBDOnRemoveQueueItems = "onQbdRemoveQueueItems",
    ShopifyPushOrder = "shopifyPushOrder",
    ShopifyOnPushOrder = "onShopifyPushOrder",
    QBOGetItemByName = "qboGetItemByName",
    QBOOnGetItemByName = "onQboGetItemByName",
    QBOGetItemByEntityId = "qboGetItemByEntityId",
    QBOOnGetItemByEntityId = "onQboGetItemByEntityId",
    OrderEntryGetRecentAccountOrderEntryItems = "orderEntryGetRecentAccountOrderEntryItems",
    OrderEntryOnGetRecentAccountOrderEntryItems = "orderEntryOnGetRecentAccountOrderEntryItems",
    CatalogRecalculateReservedQtyOnHand = "catalogRecalculateReservedQtyOnHand",
    CatalogOnRecalculateReservedQtyOnHand = "onCatalogRecalculateReservedQtyOnHand",
    VendorGetVendorsPending = "getVendorsPending",
    VendorOnGetVendorsPending = "onGetVendorsPending",
    CatalogsRecalculateReservedQtyOnHand = "catalogsRecalculateReservedQtyOnHand",
    CatalogsOnRecalculateReservedQtyOnHand = "catalogsOnRecalculateReservedQtyOnHand",
    IntakeFormProcess = "processIntakeForm",
    IntakeFormOnProcess = "onProcessIntakeForm",
    IntakeFormsGetForms = "getIntakeForms",
    IntakeFormsOnGetForms = "onGetIntakeForms",
    VendorProcessVendorPending = "processVendorPending",
    VendorOnProcessVendorPending = "onProcessVendorPending",
    QBODownloadReconciliationExcel = "qboDownloadReconciliationExcel",
    QBOOnDownloadReconciliationExcel = "onQboDownloadReconciliationExcel",
    RoutesProcessRoute = "processRoute",
    RoutesOnProcessRoute = "onProcessRoute",
    RoutesGetRoutes = "getRoutes",
    RoutesOnGetRoutes = "onGetRoutes",
    RoutesAssignRoute = "assignRoute",
    RoutesOnAssignRoute = "onAssignRoute",
    RoutesGetDailyRoutes = "getDailyRoutes",
    RoutesOnGetDailyRoutes = "onGetDailyRoutes",
    RoutesProcessDailyRoute = "processDailyRoute",
    RoutesOnProcessDailyRoute = "onProcessDailyRoute",
    RoutesOptimizeDailyRoute = "optimizeDailyRoute",
    RoutesOnOptimizeDailyRoute = "onOptimizeDailyRoute",
    AdminToggleRum = "adminToggleRum",
    AdminOnToggleRum = "onAdminToggleRum",
    TagsGetTags = "getTags",
    TagsOnGetTags = "onGetTags",
    TagsProcessTag = "processTag",
    TagsOnProcessTag = "onProcessTag",
    CartCalculateTotals = "cartCalculateTotals",
    CartOnCalculateTotals = "onCartCalculateTotals",
    QBOCreateGroupedInvoice = "qboCreateGroupedInvoice",
    QBOOnCreateGroupedInvoice = "qboOnCreateGroupedInvoice",
    StripeCreateOrGetCustomer = "stripeCreateOrGetCustomer",
    StripeOnCreateOrGetCustomer = "stripeOnCreateOrGetCustomer",
    StripeCreateSupplierVendorSetupIntent = "stripeCreateSupplierVendorSetupIntent",
    StripeOnCreateSupplierVendorSetupIntent = "stripeOnCreateSupplierVendorSetupIntent",
    TokenUpdateSettings = "tokenUpdateSettings",
    TokenOnUpdateSettings = "tokenOnUpdateSettings",
    UserJoinRoom = "userJoinRoom",
    UserOnJoinRoom = "userOnJoinRoom",
    StripeChargePayment = "stripeChargePayment",
    StripeOnChargePayment = "stripeOnChargePayment",
    QBOGetEstimateDataFromQbo = "qboGetEstimateDataFromQbo",
    QBOOnGetEstimateDataFromQbo = "onQboGetEstimateDataFromQbo",
    AdminGetActivityDetail = "adminGetActivityDetail",
    AdminOnGetActivityDetail = "onAdminGetActivityDetail",
    UserLeaveAllRooms = "userLeaveAllRooms",
    UserOnLeaveAllRooms = "userOnLeaveAllRooms",
    QBDCreateVendorSourcesFromVendors = "qbdCreateVendorSourcesFromVendors",
    QBDOnCreateVendorSourcesFromVendors = "qbdOnCreateVendorSourcesFromVendors",
    QBDReconcileSalesOrders = "qbdReconcileSalesOrders",
    QBDOnReconcileSalesOrders = "qbdOnReconcileSalesOrders",
    QBDGetQueueItemsByType = "qbdGetQueueItemsByType",
    QBDOnGetQueueItemsByType = "qbdOnGetQueueItemsByType",
    QBOForceCustomFieldActive = "qboForceCustomFieldActive",
    QBOOnForceCustomFieldActive = "qboOnForceCustomFieldActive",
    QBOToggleCustomTxnNumbers = "qboToggleCustomTxnNumbers",
    QBOOnToggleCustomTxnNumbers = "onQboToggleCustomTxnNumbers",
    CatalogsGetCatalogCSVPriceBands = "catalogsGetCatalogCSVPriceBands",
    CatalogsOnGetCatalogCSVPriceBands = "catalogsOnGetCatalogCSVPriceBands",
    CatalogsGetCatalogCSVKitBuilderTemplate = "catalogsGetCatalogCSVKitBuilderTemplate",
    CatalogsOnGetCatalogCSVKitBuilderTemplate = "catalogsOnGetCatalogCSVKitBuilderTemplate",
    CatalogsGetPriceBandsBulkApplyCsvTemplate = "catalogsGetPriceBandsBulkApplyCsvTemplate",
    CatalogsOnGetPriceBandsBulkApplyCsvTemplate = "catalogsOnGetPriceBandsBulkApplyCsvTemplate",
    CatalogsGetCatalogCSVAttributes = "catalogsGetCatalogCSVAttributes",
    CatalogsOnGetCatalogCSVAttributes = "catalogsOnGetCatalogCSVAttributes",
    CatalogsGetItemOptionsAssignCsvTemplate = "catalogsGetItemOptionsAssignCsvTemplate",
    CatalogsOnGetItemOptionsAssignCsvTemplate = "catalogsOnGetItemOptionsAssignCsvTemplate",
    AdminGetAutomations = "adminGetAutomations",
    AdminOnGetAutomations = "adminOnGetAutomations",
    AdminTriggerAutomation = "adminTriggerAutomation",
    AdminOnTriggerAutomation = "adminOnTriggerAutomation",
    FishbowlDownloadSalesOrderData = "fishbowlDownloadSalesOrderData",
    FishbowlOnDownloadSalesOrderData = "fishbowlOnDownloadSalesOrderData",
    QBODownloadJson = "qboDownloadJson",
    QBOOnDownloadJson = "qboOnDownloadJson",
    ShipmentResendShipmentEmail = "resendShipmentEmail",
    ShipmentOnResendShipmentEmail = "onResendShipmentEmail",
    TokenGetSupplierUsage = "tokenGetSupplierUsage",
    TokenOnGetSupplierUsage = "onTokenGetSupplierUsage",
    AdminAdjustSupplier = "adminAdjustSupplier",
    AdminOnAdjustSupplier = "adminOnAdjustSupplier",
    AdminGetApiOrderDetails = "adminGetApiOrderDetails",
    AdminOnGetApiOrderDetails = "onAdminGetApiOrderDetails",
    AdminProcessApiOrder = "adminProcessApiOrder",
    AdminOnProcessApiOrder = "onAdminProcessApiOrder",
    AdminQBDAddBlockedIP = "adminQBDAddBlockedIP",
    AdminOnQBDAddBlockedIP = "onAdminQBDAddBlockedIP",
    AdminQBDRemoveBlockedIP = "adminQBDRemoveBlockedIP",
    AdminOnQBDRemoveBlockedIP = "onAdminQBDRemoveBlockedIP",
    AdminQBDGetBlockedIPs = "adminQBDGetBlockedIPs",
    AdminOnQBDGetBlockedIPs = "onAdminQBDGetBlockedIPs",
    AdminDiagnostics = "adminDiagnostics",
    AdminOnDiagnostics = "onAdminDiagnostics",
    QBDGetQueueLogs = "qbdGetQueueLogs",
    QBDOnGetQueueLogs = "qbdOnGetQueueLogs",

    // Authorize.Net endpoints
    AuthNetAuthorizeCreditCard = "authNetAuthorizeCreditCard",
    AuthNetOnAuthorizeCreditCard = "onAuthNetAuthorizeCreditCard",
    AuthNetCaptureCreditCard = "authNetCaptureCreditCard",
    AuthNetOnCaptureCreditCard = "onAuthNetCaptureCreditCard",
    AuthNetAuthAndCaptureCreditCard = "authNetAuthAndCaptureCreditCard",
    AuthNetOnAuthAndCaptureCreditCard = "onAuthNetAuthAndCaptureCreditCard",
    AuthNetAcceptAuthorizeCreditCard = "authNetAcceptAuthorizeCreditCard",
    AuthNetOnAcceptAuthorizeCreditCard = "authNetOnAcceptAuthorizeCreditCard",
    AuthNetAcceptAuthAndCaptureCreditCard = "authNetAcceptAuthAndCaptureCreditCard",
    AuthNetOnAcceptAuthAndCaptureCreditCard = "authNetOnAcceptAuthAndCaptureCreditCard",
    AuthNetAcceptCaptureCreditCard = "authNetAcceptCaptureCreditCard",
    AuthNetOnAcceptCaptureCreditCard = "authNetOnAcceptCaptureCreditCard",
    AuthNetCreateCustomerProfile = "authNetCreateCustomerProfile",
    AuthNetOnCreateCustomerProfile = "onAuthNetCreateCustomerProfile",
    AuthNetGetCustomerProfile = "authNetGetCustomerProfile",
    AuthNetOnGetCustomerProfile = "onAuthNetGetCustomerProfile",
    AuthNetCreateCustomerPaymentProfile = "authNetCreateCustomerPaymentProfile",
    AuthNetOnCreateCustomerPaymentProfile = "onAuthNetCreateCustomerPaymentProfile",
    AuthNetGetCustomerPaymentProfileList = "authNetGetCustomerPaymentProfileList",
    AuthNetOnGetCustomerPaymentProfileList = "onAuthNetGetCustomerPaymentProfileList",
    AuthNetValidateCustomerPaymentProfile = "authNetValidateCustomerPaymentProfile",
    AuthNetOnValidateCustomerPaymentProfile = "onAuthNetValidateCustomerPaymentProfile",

    CatalogItemDuplicateCatalogItem = "catalogItemDuplicateCatalogItem",
    CatalogItemOnDuplicateCatalogItem = "catalogItemOnDuplicateCatalogItem",

    CatalogItemOptionCreateItemOption = "catalogItemOptionCreateItemOption",
    CatalogItemOptionOnCreateItemOption = "catalogItemOptionOnCreateItemOption",
    CatalogItemOptionUpdateItemOption = "catalogItemOptionUpdateItemOption",
    CatalogItemOptionOnUpdateItemOption = "catalogItemOptionOnUpdateItemOption",
    CatalogItemOptionGetCatalogItemOptions = "catalogItemOptionGetCatalogItemOptions",
    CatalogItemOptionOnGetCatalogItemOptions = "catalogItemOptionOnGetCatalogItemOptions",
    CatalogItemOptionDeleteItemOption = "catalogItemOptionDeleteItemOption",
    CatalogItemOptionOnDeleteItemOption = "catalogItemOptionOnDeleteItemOption",

    CatalogItemSetCatalogItemOptionValues = "catalogItemSetCatalogItemOptionValues",
    CatalogItemOnSetCatalogItemOptionValues = "catalogItemOnSetCatalogItemOptionValues",
    QBDReconcilePurchaseOrders = "qbdReconcilePurchaseOrders",
    QBDOnReconcilePurchaseOrders = "qbdOnReconcilePurchaseOrders",

    // Custom Import Endpoints
    CustomImportProcessCustomImport = "processCustomImport",
    CustomImportOnProcessCustomImport = "onProcessCustomImport",
    CustomImportGetCustomImports = "getCustomImports",
    CustomImportOnGetCustomImports = "onGetCustomImports",
    CustomImportGetCustomImport = "getCustomImport",
    CustomImportOnGetCustomImport = "onGetCustomImport",
    CustomImportDeleteCustomImport = "deleteCustomImport",
    CustomImportOnDeleteCustomImport = "onDeleteCustomImport",
    CustomImportProcessCustomImportCsvFile = "processCustomImportCsvFile",
    CustomImportOnProcessCustomImportCsvFile = "onProcessCustomImportCsvFile",

    OrderGenerateOrderPackingListPDF = "generateOrderPackingListPDF",
    OrderOnGenerateOrderPackingListPDF = "onGenerateOrderPackingListPDF",

    QBOPushVendorsStart = "qboPushVendorsStart",
    QBOPushVendorsProgress = "qboPushVendorsProgress",
    QBOPushVendorsComplete = "qboPushVendorsComplete",
    QBOPushVendorsError = "qboPushVendorsError",

    // Inventory Reset Progress (REST-initiated, socket progress)
    InventoryResetProgress = "inventoryResetProgress",
}

export default EndpointsEnum;
